import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DurationString: any;
  JSON: any;
};

export type Addon = {
  __typename?: 'Addon';
  booking: Booking;
  bookingId: Scalars['String'];
  id: Scalars['String'];
  item: Item;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type AddonPriceBreakdown = {
  __typename?: 'AddonPriceBreakdown';
  addonId: Scalars['String'];
  basePrice: Scalars['Float'];
  discount: Scalars['Float'];
  itemId: Scalars['String'];
  itemName: Scalars['String'];
  priceWithDiscount: Scalars['Float'];
  quantity: Scalars['Int'];
};

export enum AddonsErrorCode {
  RentalItemAvailability = 'RentalItemAvailability'
}

export type Admin = {
  __typename?: 'Admin';
  apiKeys: Array<ApiKey>;
  email: Scalars['String'];
  id: Scalars['String'];
  menuEntries: Array<MenuEntry>;
  name?: Maybe<Scalars['String']>;
  parsedPhone?: Maybe<ParsedPhoneNumber>;
  phoneNumber?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  sharedAccount?: Maybe<Scalars['Boolean']>;
  shops: Array<Shop>;
};

export type AdminNotificationRule = {
  __typename?: 'AdminNotificationRule';
  adminId: Scalars['ID'];
  channels: Array<NotificationChannel>;
  events: Array<NotificationEvent>;
  hoursBefore?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  locationIds: Array<Scalars['ID']>;
  sources: Array<BookingSource>;
  timeWindow: TimeWindow;
};

export type AdminNotificationRuleInput = {
  channels: Array<NotificationChannel>;
  events: Array<NotificationEvent>;
  hoursBefore?: InputMaybe<Scalars['Int']>;
  isEnabled: Scalars['Boolean'];
  locationIds: Array<Scalars['ID']>;
  sources: Array<BookingSource>;
  timeWindow: TimeWindow;
};

export type Agreement = {
  __typename?: 'Agreement';
  accepted: Scalars['Boolean'];
  name: Scalars['String'];
  signature?: Maybe<Scalars['String']>;
};

export type AgreementInput = {
  accepted: Scalars['Boolean'];
  name: Scalars['String'];
  signature?: InputMaybe<Scalars['String']>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  adminId: Scalars['String'];
  createdDate: Scalars['Date'];
  expires?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  lastUsed?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  revoked: Scalars['Boolean'];
};

export type AttachmentPersonalization = {
  __typename?: 'AttachmentPersonalization';
  height?: Maybe<Scalars['Int']>;
  size: Scalars['Int'];
  width?: Maybe<Scalars['Int']>;
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type AttachmentPersonalizationInput = {
  height?: InputMaybe<Scalars['Int']>;
  size: Scalars['Int'];
  width?: InputMaybe<Scalars['Int']>;
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type Battery = {
  __typename?: 'Battery';
  boat?: Maybe<Boat>;
  id: Scalars['ID'];
};

export type Boat = {
  __typename?: 'Boat';
  activeBooking?: Maybe<Booking>;
  activeBookingId?: Maybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  batteryId?: Maybe<Scalars['ID']>;
  /** @deprecated Use batteryId instead */
  batteryTypeId?: Maybe<Scalars['ID']>;
  boatNr: Scalars['Int'];
  engineId?: Maybe<Scalars['ID']>;
  /** @deprecated Use engineId instead */
  engineTypeId?: Maybe<Scalars['ID']>;
  externalId?: Maybe<Scalars['String']>;
  historyLogs: Array<BookingHistoryLog>;
  hullNumber?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  pastBookings: Array<Booking>;
  sailedHours: Scalars['Float'];
  shopId: Scalars['ID'];
  uvi?: Maybe<Scalars['String']>;
  voltage?: Maybe<Scalars['Int']>;
};

export type BoatDataInput = {
  batteryId?: InputMaybe<Scalars['ID']>;
  boatNr: Scalars['Int'];
  engineId?: InputMaybe<Scalars['ID']>;
  externalId?: InputMaybe<Scalars['String']>;
  hullNumber?: InputMaybe<Scalars['String']>;
  uvi?: InputMaybe<Scalars['String']>;
};

export enum BoatStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type BoatWithMetrics = {
  __typename?: 'BoatWithMetrics';
  activeBooking?: Maybe<Booking>;
  activeBookingId?: Maybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  boatNr: Scalars['Int'];
  freshness: Scalars['Float'];
  id: Scalars['String'];
  sailedToday: Scalars['Float'];
  timeInBase: Scalars['Float'];
  timeSailing: Scalars['Float'];
};

export type Booking = {
  __typename?: 'Booking';
  activeBoats: Array<Boat>;
  addons: Array<Addon>;
  boatCount: Scalars['Int'];
  cancellationExplanation?: Maybe<Scalars['String']>;
  cancellationPolicy: CancellationPolicy;
  cancellationPolicyId?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<CancellationReason>;
  cancellationWarranty?: Maybe<CancellationWarranty>;
  comments: Array<Comment>;
  communicationsHistoryLogs: Array<CommunicationsHistoryLog>;
  createdDate: Scalars['Date'];
  crewSignatures: Array<CrewSignature>;
  customer: Customer;
  customerId: Scalars['String'];
  date: Scalars['Date'];
  dropoffLocation?: Maybe<DockingLocation>;
  dropoffLocationId?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  endTime: Scalars['String'];
  externalReference?: Maybe<Scalars['String']>;
  hasItems: Scalars['Boolean'];
  historyLogs: Array<BookingHistoryLog>;
  id: Scalars['String'];
  integration?: Maybe<Integration>;
  integrationId?: Maybe<Scalars['String']>;
  lang?: Maybe<SupportedLanguage>;
  modifiedDate?: Maybe<Scalars['Date']>;
  paid: Scalars['Float'];
  pastBoats: Array<Boat>;
  payments: Array<Payment>;
  pickupLocation?: Maybe<DockingLocation>;
  pickupLocationId?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  priceBreakdown: BookingPriceBreakdown;
  priceModel: PriceModel;
  priceModelId?: Maybe<Scalars['String']>;
  product: Product;
  productId: Scalars['ID'];
  refundable: Scalars['Float'];
  resellerName?: Maybe<Scalars['String']>;
  resellerReference?: Maybe<Scalars['String']>;
  reservation?: Maybe<Reservation>;
  reservedTimeslotExpires?: Maybe<Scalars['Date']>;
  shop: Shop;
  shopId: Scalars['String'];
  source: BookingSource;
  startTime: Scalars['String'];
  status: BookingStatus;
  textMessages: Array<TextMessage>;
  type?: Maybe<Scalars['String']>;
  vouchers: Array<Voucher>;
  waiverSubmissions: Array<WaiverSubmission>;
};

export type BookingExtensionOption = {
  __typename?: 'BookingExtensionOption';
  extensionMinutes: Scalars['Int'];
};

export type BookingHistoryLog = HistoryLog & {
  __typename?: 'BookingHistoryLog';
  batteryId?: Maybe<Scalars['ID']>;
  boatIds: Array<Scalars['String']>;
  boats: Array<Boat>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  engineId?: Maybe<Scalars['ID']>;
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['String']>;
  subjectAdminId?: Maybe<Scalars['String']>;
  subjectCustomerId?: Maybe<Scalars['String']>;
  voucher?: Maybe<Voucher>;
  voucherId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export enum BookingHistoryLogRelation {
  BoatId = 'boatId',
  BookingId = 'bookingId',
  ObjectCustomerId = 'objectCustomerId',
  ShopId = 'shopId'
}

export enum BookingLocalization {
  CalendarHelpText = 'calendarHelpText',
  CancelButtonTextNoRefund = 'cancelButtonTextNoRefund',
  CancelButtonTextRefund = 'cancelButtonTextRefund',
  ChooseADate = 'chooseADate',
  CustomerFormHeading = 'customerFormHeading',
  CustomerFormText = 'customerFormText',
  DurationTimesUnavailable = 'durationTimesUnavailable',
  LastStepInfo = 'lastStepInfo',
  NewsletterText = 'newsletterText',
  NotAvailableForOnlineBooking = 'notAvailableForOnlineBooking',
  NumberOfUnits = 'numberOfUnits',
  PaymentSuccessHeading = 'paymentSuccessHeading',
  PaymentSuccessLink = 'paymentSuccessLink',
  PaymentSuccessText = 'paymentSuccessText',
  PersonsPerUnit = 'personsPerUnit',
  SailoutTimeReservedHeading = 'sailoutTimeReservedHeading',
  SailoutTimeReservedText = 'sailoutTimeReservedText',
  StepOneBoatsAndDuration = 'stepOneBoatsAndDuration',
  StepTwoDateAndTime = 'stepTwoDateAndTime',
  TermsLink = 'termsLink',
  TermsText = 'termsText',
  WarrantyLink = 'warrantyLink'
}

export type BookingLocalizations = {
  __typename?: 'BookingLocalizations';
  calendarHelpText?: Maybe<Localization>;
  cancelButtonTextNoRefund?: Maybe<Localization>;
  cancelButtonTextRefund?: Maybe<Localization>;
  chooseADate?: Maybe<Localization>;
  customerFormHeading?: Maybe<Localization>;
  customerFormText?: Maybe<Localization>;
  durationTimesUnavailable?: Maybe<Localization>;
  id: Scalars['String'];
  lastStepInfo?: Maybe<Localization>;
  modifiedDate: Scalars['Date'];
  newsletterText?: Maybe<Localization>;
  notAvailableForOnlineBooking?: Maybe<Localization>;
  numberOfUnits?: Maybe<Localization>;
  paymentSuccessHeading?: Maybe<Localization>;
  paymentSuccessLink?: Maybe<Localization>;
  paymentSuccessText?: Maybe<Localization>;
  personsPerUnit?: Maybe<Localization>;
  sailoutTimeReservedHeading?: Maybe<Localization>;
  sailoutTimeReservedText?: Maybe<Localization>;
  shopId: Scalars['String'];
  stepOneBoatsAndDuration?: Maybe<Localization>;
  stepTwoDateAndTime?: Maybe<Localization>;
  termsLink?: Maybe<Localization>;
  termsText?: Maybe<Localization>;
  warrantyLink?: Maybe<Localization>;
};

export type BookingPriceBreakdown = {
  __typename?: 'BookingPriceBreakdown';
  addonsBreakdown: Array<AddonPriceBreakdown>;
  addonsPrice: Scalars['Float'];
  addonsPriceWithDiscount: Scalars['Float'];
  boatRentalPrice: Scalars['Float'];
  boatRentalPriceWithDiscount: Scalars['Float'];
  bookingPrice: Scalars['Float'];
  bookingPriceWithDiscount: Scalars['Float'];
  cancellationWarrantyPrice: Scalars['Float'];
  donationsPrice: Scalars['Float'];
  dropoffLocationPrice: Scalars['Float'];
  flatDiscountByVoucherId: Array<FlatDiscountByVoucher>;
  pickupLocationPrice: Scalars['Float'];
  tax: Scalars['Float'];
  totalPrice: Scalars['Float'];
  voucherValueAddons: Scalars['Float'];
  voucherValueBoatRental: Scalars['Float'];
  voucherValueCombined: Scalars['Float'];
};

export type BookingSession = {
  __typename?: 'BookingSession';
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']>;
  converted: Scalars['Boolean'];
  createdDate: Scalars['Date'];
  currentStep: BookingStep;
  customerEmail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lang: SupportedLanguage;
  lastActivityDate: Scalars['Date'];
  modifiedDate: Scalars['Date'];
  reservationId?: Maybe<Scalars['ID']>;
  sessionUuid: Scalars['ID'];
  shopId?: Maybe<Scalars['ID']>;
};

export enum BookingSource {
  Online = 'ONLINE',
  Reseller = 'RESELLER',
  WalkIn = 'WALK_IN'
}

export enum BookingStatus {
  AwaitingPayment = 'AwaitingPayment',
  CanCheckin = 'CanCheckin',
  Cancelled = 'Cancelled',
  CheckedIn = 'CheckedIn',
  CheckingOut = 'CheckingOut',
  Completed = 'Completed',
  Expired = 'Expired',
  Reserved = 'Reserved',
  Sailing = 'Sailing',
  WaitListed = 'WaitListed'
}

export enum BookingStep {
  BoatsAndDuration = 'boatsAndDuration',
  ContactDetails = 'contactDetails',
  DateAndDeparture = 'dateAndDeparture',
  Extras = 'extras',
  Payment = 'payment'
}

export type BookingTrigger = {
  __typename?: 'BookingTrigger';
  createdDate: Scalars['Date'];
  enabled: Scalars['Boolean'];
  event: BookingTriggerEvent;
  id: Scalars['String'];
  modifiedDate: Scalars['Date'];
  name: Scalars['String'];
  offsetSeconds: Scalars['Int'];
  scheduledTextMessages: Array<ScheduledTextMessage>;
  shopId: Scalars['String'];
};

export enum BookingTriggerEvent {
  Creation = 'CREATION',
  GeofenceBreach = 'GEOFENCE_BREACH',
  Return = 'RETURN',
  Sailout = 'SAILOUT'
}

export type BookingTriggerInput = {
  enabled: Scalars['Boolean'];
  event: BookingTriggerEvent;
  name: Scalars['String'];
  offsetSeconds: Scalars['Int'];
};

export enum BooleanCondition {
  All = 'ALL',
  No = 'NO',
  Yes = 'YES'
}

export type BulkSendResult = {
  __typename?: 'BulkSendResult';
  notSent: Array<MessageSendFailure>;
  textMessages: Array<TextMessage>;
};

export type BusinessDay = {
  __typename?: 'BusinessDay';
  UTCClosingTime?: Maybe<Scalars['Date']>;
  UTCOpeningTime?: Maybe<Scalars['Date']>;
  businessHours: Array<BusinessHours>;
  capacity: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  durations: Array<BusinessDayDuration>;
  historyLogs: Array<BookingHistoryLog>;
  localClosingTime?: Maybe<Scalars['String']>;
  localOpeningTime?: Maybe<Scalars['String']>;
  priceModelId?: Maybe<Scalars['String']>;
  shopId: Scalars['String'];
  sunTimes: SunTimes;
};


export type BusinessDaySunTimesArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type BusinessDayDuration = {
  __typename?: 'BusinessDayDuration';
  durationNumber: Scalars['Float'];
  durationString: Scalars['DurationString'];
  priceHigh: Scalars['Int'];
  priceLow: Scalars['Int'];
};

export type BusinessHours = {
  __typename?: 'BusinessHours';
  UTCClosingTime: Scalars['Date'];
  UTCOpeningTime: Scalars['Date'];
  /** @deprecated use integrationBoats */
  availableToIntegrations?: Maybe<Scalars['Boolean']>;
  bookableBoats: Scalars['Int'];
  capacity?: Maybe<Scalars['Float']>;
  customerFacingText?: Maybe<Scalars['String']>;
  customerFacingTextLocalizations?: Maybe<Localization>;
  id: Scalars['String'];
  integrationBoats: Scalars['Int'];
  maxConcurrent: Scalars['Int'];
  minimumNoticeMinutes?: Maybe<Scalars['Int']>;
  priceModel: PriceModel;
  priceModelId?: Maybe<Scalars['String']>;
  productId: Scalars['ID'];
  sailTimes?: Maybe<Scalars['Int']>;
};


export type BusinessHoursCustomerFacingTextArgs = {
  language?: InputMaybe<SupportedLanguage>;
};

export type BusinessHoursInput = {
  bookableBoats: Scalars['Int'];
  customerFacingTextLocalizations?: InputMaybe<LocalizationInput>;
  integrationBoats: Scalars['Int'];
  localClosingTime: Scalars['String'];
  localOpeningTime: Scalars['String'];
  maxConcurrent: Scalars['Int'];
  minimumNoticeMinutes: Scalars['Int'];
  priceModelId: Scalars['String'];
  productId: Scalars['ID'];
  sailTimes: Scalars['Int'];
};

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  active?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  cancellationWarranty?: Maybe<CancellationPolicyDetails>;
  default: CancellationPolicyDetails;
  id: Scalars['String'];
  name: Scalars['String'];
  options?: Maybe<CancellationPolicyOptions>;
};

export type CancellationPolicyDetails = {
  __typename?: 'CancellationPolicyDetails';
  boatCount?: Maybe<Scalars['Int']>;
  cancel?: Maybe<Scalars['Int']>;
  customerInfo?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  extrasAdd?: Maybe<Scalars['Int']>;
  extrasRemove?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['Int']>;
  refund?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['Int']>;
  voucherRefund?: Maybe<Scalars['Int']>;
};

export type CancellationPolicyOptions = {
  __typename?: 'CancellationPolicyOptions';
  warrantyHelpTextBody?: Maybe<Array<Maybe<CancellationPolicyOptionsWarrantyHelpText>>>;
  warrantyHelpTextHeading?: Maybe<Array<Maybe<CancellationPolicyOptionsWarrantyHelpText>>>;
  warrantyPurchaseCutoff?: Maybe<Scalars['Int']>;
};

export type CancellationPolicyOptionsWarrantyHelpText = {
  __typename?: 'CancellationPolicyOptionsWarrantyHelpText';
  lang?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum CancellationReason {
  BatteryIssue = 'BATTERY_ISSUE',
  BoatIssue = 'BOAT_ISSUE',
  CustomerRequest = 'CUSTOMER_REQUEST',
  DoubleBooking = 'DOUBLE_BOOKING',
  EnvironmentWater = 'ENVIRONMENT_WATER',
  EnvironmentWeeds = 'ENVIRONMENT_WEEDS',
  EnvironmentWind = 'ENVIRONMENT_WIND',
  Other = 'OTHER',
  Schedule = 'SCHEDULE',
  Sickness = 'SICKNESS',
  StaffIssue = 'STAFF_ISSUE',
  TransportationIssue = 'TRANSPORTATION_ISSUE',
  Weather = 'WEATHER',
  WrongLocation = 'WRONG_LOCATION'
}

export type CancellationWarranty = {
  __typename?: 'CancellationWarranty';
  bookingId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Int'];
};

export enum CapitalizedWeekday {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type Checklist = {
  __typename?: 'Checklist';
  archived: Scalars['Boolean'];
  dayOfMonth?: Maybe<Scalars['Int']>;
  frequency: ChecklistFrequency;
  id: Scalars['ID'];
  nextDueDate?: Maybe<Scalars['Date']>;
  previousDueDate?: Maybe<Scalars['Date']>;
  shop: Shop;
  shopId: Scalars['ID'];
  timeOfDayUtc?: Maybe<Scalars['String']>;
  type: ChecklistType;
  weekdays: Array<Scalars['Int']>;
};

export type ChecklistCompletion = {
  __typename?: 'ChecklistCompletion';
  adminId: Scalars['ID'];
  boat?: Maybe<Boat>;
  boatId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  who: Admin;
};

export enum ChecklistFrequency {
  Custom = 'CUSTOM',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY'
}

export enum ChecklistType {
  BoatSpecific = 'BOAT_SPECIFIC',
  Generic = 'GENERIC'
}

export type Comment = {
  __typename?: 'Comment';
  admin?: Maybe<Admin>;
  adminId?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  bookingId: Scalars['String'];
  date: Scalars['Date'];
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
  text: Scalars['String'];
};

export type CommunicationsHistoryLog = HistoryLog & {
  __typename?: 'CommunicationsHistoryLog';
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  bookingTrigger?: Maybe<BookingTrigger>;
  bookingTriggerId?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  scheduledTextMessage?: Maybe<ScheduledTextMessage>;
  scheduledTextMessageId?: Maybe<Scalars['String']>;
  subjectAdminId?: Maybe<Scalars['String']>;
  textMessage?: Maybe<TextMessage>;
  textMessageId?: Maybe<Scalars['String']>;
  waiverId?: Maybe<Scalars['String']>;
  waiverVersionId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export enum CommunicationsHistoryLogRelation {
  BookingId = 'bookingId'
}

export type CrewSignature = {
  __typename?: 'CrewSignature';
  createdDate: Scalars['Date'];
  fullName: Scalars['String'];
  id: Scalars['String'];
};

export type CrewSignatureInput = {
  fullName: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<CustomerAddress>;
  birthDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastname?: Maybe<Scalars['String']>;
  objectHistoryLogs: Array<BookingHistoryLog>;
  personalIdentificationNumber?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type CustomerAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CustomerInput = {
  address?: InputMaybe<CustomerAddressInput>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  personalIdentificationNumber?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  count: Scalars['Int'];
};

export type DockingLocation = {
  __typename?: 'DockingLocation';
  address: Scalars['String'];
  default: Scalars['Boolean'];
  googleMapsLink: Scalars['String'];
  id: Scalars['ID'];
  image: DockingLocationImage;
  location: GpsCoordinates;
  minutesToBase: Scalars['Int'];
  name: Scalars['String'];
  operations: Array<DockingLocationOperation>;
  priceRange: DockingLocationPriceRange;
  shopId: Scalars['ID'];
  zone: DockingLocationZone;
  zoneId: Scalars['String'];
};

export type DockingLocationImage = {
  __typename?: 'DockingLocationImage';
  alt?: Maybe<Scalars['String']>;
  cleanedSrc: Scalars['String'];
  src: Scalars['String'];
};

export type DockingLocationImageInput = {
  alt?: InputMaybe<Scalars['String']>;
  src: Scalars['String'];
};

export type DockingLocationInput = {
  address: Scalars['String'];
  default: Scalars['Boolean'];
  image: DockingLocationImageInput;
  location: GpsCoordinatesInput;
  minutesToBase: Scalars['Int'];
  name: Scalars['String'];
  operations: Array<DockingLocationOperation>;
  zoneId: Scalars['ID'];
};

export enum DockingLocationOperation {
  Charge = 'charge',
  Clean = 'clean',
  Dropoff = 'dropoff',
  Pickup = 'pickup'
}

export type DockingLocationPriceRange = {
  __typename?: 'DockingLocationPriceRange';
  high: Scalars['Float'];
  low: Scalars['Float'];
};

export type DockingLocationZone = {
  __typename?: 'DockingLocationZone';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DockingLocationZonePrice = {
  __typename?: 'DockingLocationZonePrice';
  dockingLocationZoneId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Float'];
  priceModelId: Scalars['String'];
};

export type DockingLocationZonePriceInput = {
  dockingLocationZoneId: Scalars['String'];
  price: Scalars['Float'];
};

export type Engine = {
  __typename?: 'Engine';
  boat?: Maybe<Boat>;
  id: Scalars['ID'];
};

export type FatturaPaInvoice = {
  __typename?: 'FatturaPAInvoice';
  createdDate: Scalars['Date'];
  id: Scalars['String'];
  invoicePath?: Maybe<Scalars['String']>;
  paddedSerialNumber: Scalars['String'];
  payment: Payment;
  paymentId: Scalars['String'];
  serialNumber: Scalars['Int'];
  status: FatturaPaInvoiceStatus;
};

export enum FatturaPaInvoiceStatus {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  CreationError = 'CREATION_ERROR',
  IgnoredByGoboat = 'IGNORED_BY_GOBOAT',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean'];
  featureName: FeatureName;
  id: Scalars['String'];
  shop: Shop;
};

export enum FeatureName {
  LegacyPayments = 'LEGACY_PAYMENTS',
  LocalizedTimeDisplay = 'LOCALIZED_TIME_DISPLAY',
  MobilePayments = 'MOBILE_PAYMENTS',
  SeparateGiftcardVoucherRefunds = 'SEPARATE_GIFTCARD_VOUCHER_REFUNDS',
  StrictSailout = 'STRICT_SAILOUT',
  VoucherRefund = 'VOUCHER_REFUND',
  VoucherRefundValidForExtras = 'VOUCHER_REFUND__VALID_FOR_EXTRAS'
}

export type FeaturedItem = {
  __typename?: 'FeaturedItem';
  id: Scalars['String'];
  item: Item;
  itemId: Scalars['String'];
  position: Scalars['Int'];
  shopId: Scalars['String'];
  type: FeaturedItemType;
};

export type FeaturedItemCreateInput = {
  itemId: Scalars['String'];
  position: Scalars['Int'];
  shopId: Scalars['String'];
  type: FeaturedItemType;
};

export enum FeaturedItemType {
  Email = 'email'
}

export type FlatDiscountByVoucher = {
  __typename?: 'FlatDiscountByVoucher';
  discount: Scalars['Float'];
  voucherId: Scalars['String'];
};

export type FleetManagementHistoryLog = HistoryLog & {
  __typename?: 'FleetManagementHistoryLog';
  boat?: Maybe<Boat>;
  boatId?: Maybe<Scalars['String']>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  subjectAdminId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export type GpsCoordinates = {
  __typename?: 'GPSCoordinates';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type GpsCoordinatesInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type GeodataHistoryLog = HistoryLog & {
  __typename?: 'GeodataHistoryLog';
  boat?: Maybe<Boat>;
  boatId?: Maybe<Scalars['String']>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  subjectAdminId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export type GetAdminsResult = {
  __typename?: 'GetAdminsResult';
  admins: Array<Admin>;
  total: Scalars['Int'];
};

export type GetAndCountBookingsResult = {
  __typename?: 'GetAndCountBookingsResult';
  bookings: Array<Booking>;
  total: Scalars['Int'];
};

export type GetAndCountPaymentsResult = {
  __typename?: 'GetAndCountPaymentsResult';
  count: Scalars['Int'];
  payments: Array<Payment>;
};

export type GiftCard = {
  __typename?: 'GiftCard';
  campaignName?: Maybe<Scalars['String']>;
  campaigns: Array<Voucher>;
  createdDate: Scalars['Date'];
  customer: Customer;
  customerId: Scalars['String'];
  duration: Scalars['Float'];
  id: Scalars['String'];
  lang: SupportedLanguage;
  price: Scalars['Int'];
  priceBreakdown: GiftCardPriceBreakdown;
  recipient?: Maybe<GiftCardRecipient>;
  shop: Shop;
  shopId: Scalars['String'];
};

export enum GiftCardLocalization {
  Heading = 'heading',
  Instructions = 'instructions',
  NewsletterText = 'newsletterText',
  StepOneHeading = 'stepOneHeading',
  StepThreeHeading = 'stepThreeHeading',
  StepTwoHeading = 'stepTwoHeading'
}

export type GiftCardLocalizations = {
  __typename?: 'GiftCardLocalizations';
  heading?: Maybe<Localization>;
  id: Scalars['String'];
  instructions?: Maybe<Localization>;
  modifiedDate: Scalars['Date'];
  newsletterText?: Maybe<Localization>;
  shopId: Scalars['String'];
  stepOneHeading?: Maybe<Localization>;
  stepThreeHeading?: Maybe<Localization>;
  stepTwoHeading?: Maybe<Localization>;
};

export type GiftCardPriceBreakdown = {
  __typename?: 'GiftCardPriceBreakdown';
  balance: Scalars['Float'];
  campaignValue: Scalars['Float'];
  giftCardPrice: Scalars['Float'];
  giftCardValue: Scalars['Float'];
  tax: Scalars['Float'];
  totalPayment: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type GiftCardRecipient = {
  __typename?: 'GiftCardRecipient';
  name?: Maybe<Scalars['String']>;
};

export type GiftcardDuration = {
  __typename?: 'GiftcardDuration';
  duration: Scalars['DurationString'];
  price: Scalars['Int'];
};

export type HistoryLog = {
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  subjectAdminId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export type HistoryLogWho = {
  __typename?: 'HistoryLogWho';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Integration = {
  __typename?: 'Integration';
  bookings: Array<Booking>;
  cancellationPolicy?: Maybe<CancellationPolicy>;
  cancellationPolicyId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Date']>;
  fields: Array<IntegrationField>;
  id: Scalars['String'];
  modifiedDate?: Maybe<Scalars['Date']>;
  products: Array<IntegrationProduct>;
  service: Service;
  shop: Shop;
  shopId: Scalars['String'];
};

export type IntegrationField = {
  __typename?: 'IntegrationField';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IntegrationFieldInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type IntegrationProduct = {
  __typename?: 'IntegrationProduct';
  addons?: Maybe<Array<IntegrationProductAddon>>;
  duration: Scalars['DurationString'];
  id: Scalars['String'];
  integration: Integration;
  integrationId: Scalars['String'];
  product: Product;
  productId: Scalars['ID'];
};

export type IntegrationProductAddon = {
  __typename?: 'IntegrationProductAddon';
  id: Scalars['String'];
  integrationProduct: IntegrationProduct;
  integrationProductId: Scalars['String'];
  item: Item;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type IntegrationProductAddonInput = {
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type IntegrationProductInput = {
  duration: Scalars['DurationString'];
  productId: Scalars['ID'];
};

export type Item = {
  __typename?: 'Item';
  alcoholUnits?: Maybe<Scalars['Float']>;
  archived?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use itemCategories instead */
  category?: Maybe<Scalars['String']>;
  categoryNames: Array<Scalars['String']>;
  createdDate: Scalars['Date'];
  days: Array<ItemDays>;
  description?: Maybe<Scalars['String']>;
  displayedOn: Array<View>;
  donation?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<ItemDuration>;
  formattedPrice: Scalars['String'];
  highlighted?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  /** @deprecated Use parsedImagePath instead */
  imagepath?: Maybe<Scalars['String']>;
  itemCategories: Array<ItemCategory>;
  localizedDescription?: Maybe<Localization>;
  localizedName?: Maybe<Localization>;
  localizedShortDescription?: Maybe<Localization>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  parsedImagePath?: Maybe<Scalars['String']>;
  preBook?: Maybe<Scalars['Boolean']>;
  preBookCutoff?: Maybe<Scalars['Float']>;
  price: Scalars['Int'];
  rentalItem?: Maybe<Scalars['Boolean']>;
  rentalStock?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
  stock: Scalars['Int'];
  times?: Maybe<ItemTimes>;
  trackingName: Scalars['String'];
  useCustomPreBookCutoff?: Maybe<Scalars['Boolean']>;
};


export type ItemCategoryNamesArgs = {
  language?: InputMaybe<SupportedLanguage>;
};


export type ItemDescriptionArgs = {
  language?: InputMaybe<SupportedLanguage>;
};


export type ItemFormattedPriceArgs = {
  language?: InputMaybe<SupportedLanguage>;
};


export type ItemNameArgs = {
  language?: InputMaybe<SupportedLanguage>;
};


export type ItemShortDescriptionArgs = {
  language?: InputMaybe<SupportedLanguage>;
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  activeItems: Array<Item>;
  id: Scalars['String'];
  items: Array<Item>;
  localizedNames: Localization;
  name: Scalars['String'];
};


export type ItemCategoryActiveItemsArgs = {
  view?: InputMaybe<View>;
};


export type ItemCategoryNameArgs = {
  language: SupportedLanguage;
};

export type ItemCreateInput = {
  alcoholUnits?: InputMaybe<Scalars['Float']>;
  categoryIds: Array<Scalars['String']>;
  days: Array<ItemDaysInput>;
  description: LocalizationInput;
  displayedOn: Array<View>;
  donation?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<ItemDurationInput>;
  highlighted?: InputMaybe<Scalars['Boolean']>;
  imagePath?: InputMaybe<Scalars['String']>;
  name: LocalizationInput;
  order?: InputMaybe<Scalars['Int']>;
  preBook?: InputMaybe<Scalars['Boolean']>;
  preBookCutoff?: InputMaybe<Scalars['Float']>;
  price: Scalars['Int'];
  rentalItem?: InputMaybe<Scalars['Boolean']>;
  rentalStock?: InputMaybe<Scalars['Int']>;
  shopId: Scalars['String'];
  shortDescription: LocalizationInput;
  stock: Scalars['Int'];
  times?: InputMaybe<ItemTimesInput>;
  useCustomPreBookCutoff?: InputMaybe<Scalars['Boolean']>;
};

export type ItemDays = {
  __typename?: 'ItemDays';
  available?: Maybe<Scalars['Boolean']>;
  weekday: Scalars['String'];
};

export type ItemDaysInput = {
  available: Scalars['Boolean'];
  weekday: Scalars['String'];
};

export type ItemDuration = {
  __typename?: 'ItemDuration';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type ItemDurationInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type ItemInput = {
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type ItemReservation = {
  __typename?: 'ItemReservation';
  id: Scalars['String'];
  item: Item;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
  reservation: Reservation;
  reservationId: Scalars['String'];
};

export enum ItemStatus {
  Active = 'active',
  Archived = 'archived'
}

export type ItemTimes = {
  __typename?: 'ItemTimes';
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
};

export type ItemTimesInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
};

export type ItemUpdateInput = {
  alcoholUnits?: InputMaybe<Scalars['Float']>;
  categoryIds: Array<Scalars['String']>;
  days: Array<ItemDaysInput>;
  description: LocalizationInput;
  displayedOn: Array<View>;
  donation?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<ItemDurationInput>;
  highlighted?: InputMaybe<Scalars['Boolean']>;
  imagePath?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preBook?: InputMaybe<Scalars['Boolean']>;
  preBookCutoff?: InputMaybe<Scalars['Float']>;
  rentalItem?: InputMaybe<Scalars['Boolean']>;
  rentalStock?: InputMaybe<Scalars['Int']>;
  shortDescription: LocalizationInput;
  stock: Scalars['Int'];
  times?: InputMaybe<ItemTimesInput>;
  useCustomPreBookCutoff?: InputMaybe<Scalars['Boolean']>;
};

export type Localization = {
  __typename?: 'Localization';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
  it?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type LocalizationInput = {
  da?: InputMaybe<Scalars['String']>;
  de?: InputMaybe<Scalars['String']>;
  en?: InputMaybe<Scalars['String']>;
  es?: InputMaybe<Scalars['String']>;
  fr?: InputMaybe<Scalars['String']>;
  it?: InputMaybe<Scalars['String']>;
  sv?: InputMaybe<Scalars['String']>;
};

export type LocalizedMailchimpList = {
  __typename?: 'LocalizedMailchimpList';
  id: Scalars['String'];
  interestId?: Maybe<Scalars['String']>;
  language: Scalars['String'];
};

export type LocalizedMailchimpListInput = {
  id: Scalars['String'];
  interestId?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type MailchimpConfig = {
  __typename?: 'MailchimpConfig';
  apiKey: Scalars['String'];
  archived?: Maybe<Scalars['Boolean']>;
  defaultListId: Scalars['String'];
  id: Scalars['String'];
  interestId?: Maybe<Scalars['String']>;
  localizedLists: Array<LocalizedMailchimpList>;
  shopId: Scalars['String'];
  testListId?: Maybe<Scalars['String']>;
};

export type MailchimpConfigInput = {
  apiKey: Scalars['String'];
  defaultListId: Scalars['String'];
  interestId?: InputMaybe<Scalars['String']>;
  localizedLists: Array<LocalizedMailchimpListInput>;
  testListId?: InputMaybe<Scalars['String']>;
};

export type MailchimpSubscriberInput = {
  birthday?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullname: Scalars['String'];
};

export type MediaUploadLink = {
  __typename?: 'MediaUploadLink';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type Membership = {
  __typename?: 'Membership';
  customer: Customer;
  customerId: Scalars['String'];
  endDate: Scalars['Date'];
  id: Scalars['String'];
  lang: SupportedLanguage;
  plan: Plan;
  planId: Scalars['String'];
  priceBreakdown: MembershipPriceBreakdown;
  shop: Shop;
  shopId: Scalars['String'];
  startDate: Scalars['Date'];
  vouchers: Array<Voucher>;
};

export type MembershipPlanName = {
  __typename?: 'MembershipPlanName';
  da: Scalars['String'];
  en: Scalars['String'];
  sv: Scalars['String'];
};

export type MembershipPriceBreakdown = {
  __typename?: 'MembershipPriceBreakdown';
  balance: Scalars['Float'];
  membershipPrice: Scalars['Float'];
  tax: Scalars['Float'];
  totalPayment: Scalars['Float'];
  totalPrice: Scalars['Float'];
  voucherValue: Scalars['Float'];
};

export type MenuCategory = {
  __typename?: 'MenuCategory';
  entries: Array<MenuEntry>;
  icon?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MenuEntry = MenuCategory | MenuItem;

export type MenuItem = {
  __typename?: 'MenuItem';
  icon?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type MessageSendFailure = {
  __typename?: 'MessageSendFailure';
  entityId: Scalars['String'];
  errorMessage: Scalars['String'];
};

export type MinorSignature = {
  __typename?: 'MinorSignature';
  birthDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
};

export type MinorSignatureInput = {
  birthDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAdminApiKey: Admin;
  addAdminRoles: Admin;
  addAdminShopAccesses: Admin;
  addCancellationWarranty: Booking;
  addComment: Comment;
  addIntegrationProducts?: Maybe<Integration>;
  addItemToBooking: Addon;
  addItemsToIntegrationProduct: IntegrationProduct;
  applyVoucherToBooking: Booking;
  archiveBoat: Boat;
  archiveItem: Item;
  archiveMailchimpConfig: MailchimpConfig;
  assignBoatsToBooking: Booking;
  cancelBooking: Booking;
  checkOutAllBookings: Scalars['Boolean'];
  confirmBookingPayment: Booking;
  confirmCreateBookingPayment: Booking;
  confirmEditBooking: Booking;
  confirmEditBookingPayment: Booking;
  createAdmin: Admin;
  createAdminNotificationRule: AdminNotificationRule;
  createBoat: Boat;
  createBookingPaymentIntent: Scalars['String'];
  createBookingTrigger: BookingTrigger;
  createDockingLocation: DockingLocation;
  createDockingLocationZone: DockingLocationZone;
  createFatturaPAInvoice: FatturaPaInvoice;
  createIntegration?: Maybe<Integration>;
  createItem: Item;
  createItemCategory: ItemCategory;
  createMailchimpConfig: MailchimpConfig;
  createPayForBookingPaymentIntent: Scalars['String'];
  createPayment: Payment;
  createPriceModel: PriceModel;
  createRefund: Payment;
  createReservationPaymentIntent: Scalars['String'];
  createScheduledTextMessage: ScheduledTextMessage;
  createSendgridEmail: SendgridEmail;
  createSendgridEmailAttachment: SendgridEmailAttachment;
  createService?: Maybe<Service>;
  createStripeRefund: Payment;
  createVoucherRefund: Payment;
  createWaiver: Waiver;
  createWaiverVersion: WaiverVersion;
  createWalkin: Booking;
  customerConfirmBooking: Booking;
  deleteComment: Scalars['Boolean'];
  deleteIntegration?: Maybe<Scalars['String']>;
  deleteSendgridEmail: Scalars['Boolean'];
  deleteSendgridEmailAttachment: Scalars['Boolean'];
  editAdmin: Admin;
  editBooking: Booking;
  editScheduledTextMessage: ScheduledTextMessage;
  editSendgridEmail: SendgridEmail;
  editSendgridEmailAttachment: SendgridEmailAttachment;
  editWaiver: Waiver;
  editWaiverVersion: WaiverVersion;
  expireBooking: Booking;
  freeUpBoats: Array<Boat>;
  generateSignedMediaUploadLink: MediaUploadLink;
  getInvoiceDownloadLink: Scalars['String'];
  initiatePaymentCreateBooking: Booking;
  initiatePaymentEditBooking: Booking;
  initiatePaymentPayForBooking: Booking;
  invalidateVoucherRefund: Payment;
  invalidateWholesalePayment: Payment;
  recordSessionActivity: Scalars['Boolean'];
  redeemReceiptToken: ReceiptToken;
  refreshBookingReservation: RefreshBookingReservationResult;
  registerDispatchedEmail: Scalars['Boolean'];
  registerFatturaPAInvoice: FatturaPaInvoice;
  removeAdminRoles: Admin;
  removeAdminShopAccesses: Admin;
  removeCancellationWarranty: Booking;
  removeIntegrationProducts?: Maybe<Integration>;
  removeItemFromIntegrationProduct: IntegrationProduct;
  removeVoucherFromBooking: Booking;
  requestReceiptToken: ReceiptToken;
  resellerConfirmBooking: Booking;
  reserve: Booking;
  reserveTimeslot: Reservation;
  restoreComment: Comment;
  revokeApiKey: ApiKey;
  sendInternalEmail: Scalars['Boolean'];
  sendInternalTextMessage: Scalars['Boolean'];
  sendMultipleScheduledTextMessages: BulkSendResult;
  sendMultipleTextMessages: BulkSendResult;
  sendScheduledTextMessage: TextMessage;
  sendTextMessage: Scalars['Boolean'];
  setActiveWaiver: Waiver;
  setActiveWaiverVersion: WaiverVersion;
  setAdminPassword: Admin;
  setBookingAddons: Booking;
  setBookingLanguage: Booking;
  setBookingLocalization: BookingLocalizations;
  setBusinessDays?: Maybe<Scalars['Boolean']>;
  setCancellationReason: Booking;
  setFeatureFlag: FeatureFlag;
  setFeaturedItems: Array<FeaturedItem>;
  setGiftCardLocalization: GiftCardLocalizations;
  setInactiveWaiver: Waiver;
  setReservationItems: Reservation;
  setSailingAndRestoreBoats: Booking;
  setShopConfiguration: ShopConfiguration;
  setTextMessagingSettings: TextMessagingSettings;
  setUspBannerEntries: Scalars['Int'];
  submitDockTypeWaiver: Scalars['Int'];
  submitWaiver: WaiverSubmission;
  triggerBookingTrigger: Scalars['Boolean'];
  unarchiveBoat: Boat;
  unarchiveItem: Item;
  updateAdminNotificationRule: AdminNotificationRule;
  updateAndValidateCustomer: Customer;
  updateBoat: Boat;
  updateBookingStatus: Booking;
  updateBookingTrigger: BookingTrigger;
  updateCustomer: Customer;
  updateDockingLocation: DockingLocation;
  updateFatturaPAInvoice: FatturaPaInvoice;
  updateIntegration?: Maybe<Integration>;
  updateItem: Item;
  updateItemCategory: ItemCategory;
  updateMailchimpConfig: MailchimpConfig;
  updatePaymentIntentAmount: Scalars['Int'];
  updateSelf: Admin;
  updateService?: Maybe<Service>;
  updateTextMessageStatus: TextMessage;
  upsertGiftCardNewsletterSubscriber: Scalars['Boolean'];
  upsertNewsletterSubscriber: Scalars['Boolean'];
};


export type MutationAddAdminApiKeyArgs = {
  adminId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddAdminRolesArgs = {
  adminId: Scalars['String'];
  roleIds: Array<Scalars['String']>;
};


export type MutationAddAdminShopAccessesArgs = {
  adminId: Scalars['String'];
  shopIds: Array<Scalars['String']>;
};


export type MutationAddCancellationWarrantyArgs = {
  bookingId: Scalars['String'];
};


export type MutationAddCommentArgs = {
  author?: InputMaybe<Scalars['String']>;
  bookingId: Scalars['String'];
  text: Scalars['String'];
};


export type MutationAddIntegrationProductsArgs = {
  integrationId: Scalars['String'];
  products: Array<IntegrationProductInput>;
};


export type MutationAddItemToBookingArgs = {
  bookingId: Scalars['String'];
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};


export type MutationAddItemsToIntegrationProductArgs = {
  integrationProductId: Scalars['String'];
  items: Array<IntegrationProductAddonInput>;
};


export type MutationApplyVoucherToBookingArgs = {
  bookingId: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['String']>;
  voucherCode: Scalars['String'];
};


export type MutationArchiveBoatArgs = {
  boatId: Scalars['String'];
};


export type MutationArchiveItemArgs = {
  id: Scalars['String'];
};


export type MutationArchiveMailchimpConfigArgs = {
  id: Scalars['String'];
};


export type MutationAssignBoatsToBookingArgs = {
  boatIds: Array<Scalars['String']>;
  bookingId: Scalars['String'];
};


export type MutationCancelBookingArgs = {
  cancellationExplanation?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  idempotent?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<CancellationReason>;
  voucherRefund?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCheckOutAllBookingsArgs = {
  shopId: Scalars['String'];
};


export type MutationConfirmBookingPaymentArgs = {
  paymentIntentId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationConfirmCreateBookingPaymentArgs = {
  paymentIntentId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationConfirmEditBookingArgs = {
  reservationId: Scalars['String'];
  subToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationConfirmEditBookingPaymentArgs = {
  paymentIntentId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationCreateAdminArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  roleIds: Array<Scalars['String']>;
  sharedAccount?: InputMaybe<Scalars['Boolean']>;
  shopIds: Array<Scalars['String']>;
};


export type MutationCreateAdminNotificationRuleArgs = {
  input: AdminNotificationRuleInput;
};


export type MutationCreateBoatArgs = {
  boatData: BoatDataInput;
  shopId: Scalars['String'];
};


export type MutationCreateBookingPaymentIntentArgs = {
  id: Scalars['String'];
};


export type MutationCreateBookingTriggerArgs = {
  shopId: Scalars['String'];
  trigger: BookingTriggerInput;
};


export type MutationCreateDockingLocationArgs = {
  input: DockingLocationInput;
  shopId: Scalars['ID'];
};


export type MutationCreateDockingLocationZoneArgs = {
  name: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationCreateFatturaPaInvoiceArgs = {
  paymentId: Scalars['String'];
};


export type MutationCreateIntegrationArgs = {
  fields: Array<IntegrationFieldInput>;
  serviceId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationCreateItemArgs = {
  input: ItemCreateInput;
};


export type MutationCreateItemCategoryArgs = {
  name: LocalizationInput;
  shopId: Scalars['String'];
};


export type MutationCreateMailchimpConfigArgs = {
  config: MailchimpConfigInput;
  shopId: Scalars['String'];
};


export type MutationCreatePayForBookingPaymentIntentArgs = {
  bookingId: Scalars['String'];
};


export type MutationCreatePaymentArgs = {
  amount: Scalars['Float'];
  bookingId: Scalars['String'];
  creator?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type MutationCreatePriceModelArgs = {
  input: PriceModelInput;
};


export type MutationCreateRefundArgs = {
  amount: Scalars['Float'];
  bookingId: Scalars['String'];
  creator?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type MutationCreateReservationPaymentIntentArgs = {
  reservationId: Scalars['String'];
};


export type MutationCreateScheduledTextMessageArgs = {
  message: ScheduledTextMessageInput;
  shopId: Scalars['String'];
};


export type MutationCreateSendgridEmailArgs = {
  attachmentIds: Array<Scalars['String']>;
  email: SendgridEmailInput;
};


export type MutationCreateSendgridEmailAttachmentArgs = {
  attachment: SendgridEmailAttachmentInput;
};


export type MutationCreateServiceArgs = {
  description: Scalars['String'];
  fields: Array<ServiceFieldInput>;
  name: Scalars['String'];
  type: ServiceType;
};


export type MutationCreateStripeRefundArgs = {
  amount: Scalars['Float'];
  creator?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
};


export type MutationCreateVoucherRefundArgs = {
  amount: Scalars['Float'];
  creator?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
};


export type MutationCreateWaiverArgs = {
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  name: Scalars['String'];
  shopId: Scalars['String'];
  type: WaiverType;
};


export type MutationCreateWaiverVersionArgs = {
  data: WaiverVersionInput;
};


export type MutationCreateWalkinArgs = {
  boatCount: Scalars['Int'];
  customer: CustomerInput;
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  lang?: InputMaybe<SupportedLanguage>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['String']>;
};


export type MutationCustomerConfirmBookingArgs = {
  bookingId: Scalars['String'];
  subToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSendgridEmailArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSendgridEmailAttachmentArgs = {
  id: Scalars['String'];
};


export type MutationEditAdminArgs = {
  id: Scalars['String'];
  sharedAccount?: InputMaybe<Scalars['Boolean']>;
};


export type MutationEditBookingArgs = {
  boatCount: Scalars['Int'];
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  forfeitRentalItems?: InputMaybe<Scalars['Boolean']>;
  forfeitVouchers?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  pickupLocationId?: InputMaybe<Scalars['String']>;
};


export type MutationEditScheduledTextMessageArgs = {
  id: Scalars['String'];
  message: ScheduledTextMessageInput;
};


export type MutationEditSendgridEmailArgs = {
  attachmentIds: Array<Scalars['String']>;
  email: SendgridEmailInput;
  id: Scalars['String'];
};


export type MutationEditSendgridEmailAttachmentArgs = {
  attachment: SendgridEmailAttachmentInput;
  id: Scalars['String'];
};


export type MutationEditWaiverArgs = {
  id: Scalars['String'];
  waiver: WaiverInput;
};


export type MutationEditWaiverVersionArgs = {
  id: Scalars['String'];
  waiverVersion: WaiverVersionInput;
};


export type MutationExpireBookingArgs = {
  id: Scalars['String'];
};


export type MutationFreeUpBoatsArgs = {
  boatIds: Array<Scalars['String']>;
};


export type MutationGenerateSignedMediaUploadLinkArgs = {
  filename: Scalars['String'];
  folderName?: InputMaybe<Scalars['String']>;
};


export type MutationGetInvoiceDownloadLinkArgs = {
  paymentId: Scalars['String'];
};


export type MutationInitiatePaymentCreateBookingArgs = {
  bookingId: Scalars['String'];
  clientPrice: Scalars['Int'];
  paymentIntentId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInitiatePaymentEditBookingArgs = {
  bookingId: Scalars['String'];
  clientPrice: Scalars['Int'];
  paymentIntentId: Scalars['String'];
  reservationId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInitiatePaymentPayForBookingArgs = {
  bookingId: Scalars['String'];
  clientPrice: Scalars['Int'];
  paymentIntentId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInvalidateVoucherRefundArgs = {
  creator?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
};


export type MutationInvalidateWholesalePaymentArgs = {
  creator?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
};


export type MutationRecordSessionActivityArgs = {
  input: RecordSessionActivityInput;
};


export type MutationRedeemReceiptTokenArgs = {
  id: Scalars['String'];
};


export type MutationRefreshBookingReservationArgs = {
  bookingId: Scalars['String'];
};


export type MutationRegisterDispatchedEmailArgs = {
  bookingId: Scalars['ID'];
  sendgridEmailId: Scalars['ID'];
  to: Scalars['String'];
};


export type MutationRegisterFatturaPaInvoiceArgs = {
  invoicePath?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
  status: FatturaPaInvoiceStatus;
};


export type MutationRemoveAdminRolesArgs = {
  adminId: Scalars['String'];
  roleIds: Array<Scalars['String']>;
};


export type MutationRemoveAdminShopAccessesArgs = {
  adminId: Scalars['String'];
  shopIds: Array<Scalars['String']>;
};


export type MutationRemoveCancellationWarrantyArgs = {
  bookingId: Scalars['String'];
};


export type MutationRemoveIntegrationProductsArgs = {
  integrationId: Scalars['String'];
  productIds: Array<Scalars['String']>;
};


export type MutationRemoveItemFromIntegrationProductArgs = {
  integrationProductAddonId: Scalars['String'];
  integrationProductId: Scalars['String'];
};


export type MutationRemoveVoucherFromBookingArgs = {
  bookingId: Scalars['String'];
  voucherId: Scalars['String'];
};


export type MutationRequestReceiptTokenArgs = {
  entityId: Scalars['String'];
  type: ReceiptTokenType;
};


export type MutationResellerConfirmBookingArgs = {
  bookingId: Scalars['String'];
  comments?: InputMaybe<Array<Scalars['String']>>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  customerDetails: CustomerInput;
  paymentAmount: Scalars['Float'];
  paymentCreator: Scalars['String'];
  resellerReference?: InputMaybe<Scalars['String']>;
};


export type MutationReserveArgs = {
  boatCount: Scalars['Int'];
  customer: CustomerInput;
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  externalReference?: InputMaybe<Scalars['String']>;
  includeWarranty?: InputMaybe<Scalars['Boolean']>;
  integrationId?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<SupportedLanguage>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  resellerName?: InputMaybe<Scalars['String']>;
  resellerReference?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['String']>;
};


export type MutationReserveTimeslotArgs = {
  boatCount: Scalars['Int'];
  bookingId: Scalars['String'];
  date: Scalars['Date'];
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  forfeitRentalItems?: InputMaybe<Scalars['Boolean']>;
  items: Array<ItemInput>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
};


export type MutationRestoreCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationRevokeApiKeyArgs = {
  id: Scalars['String'];
};


export type MutationSendInternalEmailArgs = {
  html?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  text: Scalars['String'];
  to: Scalars['String'];
};


export type MutationSendInternalTextMessageArgs = {
  recipientNumber: Scalars['String'];
  text: Scalars['String'];
};


export type MutationSendMultipleScheduledTextMessagesArgs = {
  bookingIds: Array<Scalars['String']>;
  scheduledTextMessageId: Scalars['String'];
};


export type MutationSendMultipleTextMessagesArgs = {
  body: Scalars['String'];
  bookingIds: Array<Scalars['String']>;
};


export type MutationSendScheduledTextMessageArgs = {
  bookingId: Scalars['String'];
  recipientNumber?: InputMaybe<Scalars['String']>;
  scheduledTextMessageId: Scalars['String'];
};


export type MutationSendTextMessageArgs = {
  bookingId: Scalars['String'];
  recipientNumber: Scalars['String'];
  text: Scalars['String'];
};


export type MutationSetActiveWaiverArgs = {
  id: Scalars['String'];
};


export type MutationSetActiveWaiverVersionArgs = {
  id: Scalars['String'];
};


export type MutationSetAdminPasswordArgs = {
  adminId: Scalars['ID'];
  password: Scalars['String'];
};


export type MutationSetBookingAddonsArgs = {
  bookingId: Scalars['String'];
  items: Array<ItemInput>;
};


export type MutationSetBookingLanguageArgs = {
  id: Scalars['String'];
  language: SupportedLanguage;
};


export type MutationSetBookingLocalizationArgs = {
  localization: BookingLocalization;
  shopId: Scalars['String'];
  values: LocalizationInput;
};


export type MutationSetBusinessDaysArgs = {
  businessHours: Array<BusinessHoursInput>;
  comment?: InputMaybe<Scalars['String']>;
  dates: Array<Scalars['Date']>;
  shopId: Scalars['String'];
};


export type MutationSetCancellationReasonArgs = {
  explanation?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  reason: CancellationReason;
};


export type MutationSetFeatureFlagArgs = {
  enabled: Scalars['Boolean'];
  featureName: FeatureName;
  shopId: Scalars['String'];
};


export type MutationSetFeaturedItemsArgs = {
  items: Array<FeaturedItemCreateInput>;
};


export type MutationSetGiftCardLocalizationArgs = {
  localization: GiftCardLocalization;
  shopId: Scalars['String'];
  values: LocalizationInput;
};


export type MutationSetInactiveWaiverArgs = {
  id: Scalars['String'];
};


export type MutationSetReservationItemsArgs = {
  items: Array<ItemInput>;
  reservationId: Scalars['String'];
};


export type MutationSetSailingAndRestoreBoatsArgs = {
  id: Scalars['String'];
};


export type MutationSetShopConfigurationArgs = {
  input: ShopConfigurationInput;
  shopId: Scalars['String'];
};


export type MutationSetTextMessagingSettingsArgs = {
  settings: TextMessagingSettingsInput;
  shopId: Scalars['String'];
};


export type MutationSetUspBannerEntriesArgs = {
  input: Array<UspBannerInput>;
  language: SupportedLanguage;
  shopId: Scalars['String'];
};


export type MutationSubmitDockTypeWaiverArgs = {
  bookingId: Scalars['String'];
  crewSignature: CrewSignatureInput;
  signatures: Array<SignatureInput>;
  waiverVersionId: Scalars['String'];
};


export type MutationSubmitWaiverArgs = {
  agreements: Array<AgreementInput>;
  bookingId: Scalars['String'];
  data: WaiverData;
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  minors?: InputMaybe<Array<MinorSignatureInput>>;
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
  waiverVersionId: Scalars['String'];
};


export type MutationTriggerBookingTriggerArgs = {
  boatExternalId?: InputMaybe<Scalars['String']>;
  bookingId: Scalars['String'];
  event: BookingTriggerEvent;
  geofenceName?: InputMaybe<Scalars['String']>;
};


export type MutationUnarchiveBoatArgs = {
  boatId: Scalars['String'];
};


export type MutationUnarchiveItemArgs = {
  id: Scalars['String'];
};


export type MutationUpdateAdminNotificationRuleArgs = {
  id: Scalars['ID'];
  input: AdminNotificationRuleInput;
};


export type MutationUpdateAndValidateCustomerArgs = {
  id: Scalars['String'];
  input: CustomerInput;
};


export type MutationUpdateBoatArgs = {
  boatData: BoatDataInput;
  boatId: Scalars['String'];
};


export type MutationUpdateBookingStatusArgs = {
  id: Scalars['String'];
  status: BookingStatus;
};


export type MutationUpdateBookingTriggerArgs = {
  id: Scalars['String'];
  trigger: BookingTriggerInput;
};


export type MutationUpdateCustomerArgs = {
  id: Scalars['String'];
  input: CustomerInput;
};


export type MutationUpdateDockingLocationArgs = {
  id: Scalars['ID'];
  input: DockingLocationInput;
};


export type MutationUpdateFatturaPaInvoiceArgs = {
  invoicePath?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
  status: FatturaPaInvoiceStatus;
};


export type MutationUpdateIntegrationArgs = {
  cancellationPolicyId?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<IntegrationFieldInput>>;
  id: Scalars['String'];
};


export type MutationUpdateItemArgs = {
  id: Scalars['String'];
  input: ItemUpdateInput;
};


export type MutationUpdateItemCategoryArgs = {
  id: Scalars['String'];
  name: LocalizationInput;
};


export type MutationUpdateMailchimpConfigArgs = {
  config: MailchimpConfigInput;
  id: Scalars['String'];
};


export type MutationUpdatePaymentIntentAmountArgs = {
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  reservationId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateSelfArgs = {
  data: UpdateAdminInput;
};


export type MutationUpdateServiceArgs = {
  description: Scalars['String'];
  fields: Array<ServiceFieldInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: ServiceType;
};


export type MutationUpdateTextMessageStatusArgs = {
  messageSid: Scalars['String'];
  status: TextMessageStatus;
  timestamp: Scalars['Date'];
};


export type MutationUpsertGiftCardNewsletterSubscriberArgs = {
  giftCardId: Scalars['String'];
  subscribed: Scalars['Boolean'];
  subscriber: MailchimpSubscriberInput;
};


export type MutationUpsertNewsletterSubscriberArgs = {
  bookingId: Scalars['String'];
  subscribed: Scalars['Boolean'];
  subscriber: MailchimpSubscriberInput;
};

export enum NotificationChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum NotificationEvent {
  BookingCancelled = 'BOOKING_CANCELLED',
  BookingCreated = 'BOOKING_CREATED',
  BookingMovedByAdmin = 'BOOKING_MOVED_BY_ADMIN',
  BookingMovedByCustomer = 'BOOKING_MOVED_BY_CUSTOMER'
}

export type OldAttachment = {
  __typename?: 'OldAttachment';
  path?: Maybe<Scalars['String']>;
  personalization?: Maybe<Scalars['JSON']>;
};

export type PaginatedBookingHistoryLogs = {
  __typename?: 'PaginatedBookingHistoryLogs';
  logs: Array<BookingHistoryLog>;
  totalCount: Scalars['Int'];
};

export type PaginatedCommunicationsHistoryLogs = {
  __typename?: 'PaginatedCommunicationsHistoryLogs';
  logs: Array<CommunicationsHistoryLog>;
  totalCount: Scalars['Int'];
};

export type PaginatedItems = {
  __typename?: 'PaginatedItems';
  items: Array<Item>;
  total: Scalars['Int'];
};

export type PaginatedWaiverSubmissions = {
  __typename?: 'PaginatedWaiverSubmissions';
  submissions: Array<WaiverSubmission>;
  totalCount: Scalars['Int'];
};

export type ParsedPhoneNumber = {
  __typename?: 'ParsedPhoneNumber';
  country?: Maybe<Scalars['String']>;
  countryCallingCode?: Maybe<Scalars['String']>;
  nationalNumber?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float'];
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['String']>;
  commission?: Maybe<Scalars['Float']>;
  createdDate: Scalars['Date'];
  creator?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  fatturaPAInvoice?: Maybe<FatturaPaInvoice>;
  fatturaPASerial: Scalars['String'];
  giftCard?: Maybe<GiftCard>;
  giftcardId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invalidated?: Maybe<Scalars['Boolean']>;
  refundVoucher?: Maybe<Voucher>;
  refundedPayment?: Maybe<Payment>;
  stripeId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  voucherId?: Maybe<Scalars['String']>;
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['String'];
  name: MembershipPlanName;
};

export type PriceModel = {
  __typename?: 'PriceModel';
  archived?: Maybe<Scalars['Boolean']>;
  cancellationWarranty?: Maybe<PriceModelWarranty>;
  createdDate?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  default: Scalars['Boolean'];
  defaultDurationBooking?: Maybe<Scalars['String']>;
  defaultDurationGiftcard?: Maybe<Scalars['String']>;
  dockingLocationZonePrices: Array<DockingLocationZonePrice>;
  durations: Array<PriceModelDuration>;
  giftcards?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  inUse?: Maybe<Scalars['Boolean']>;
  modifiedDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['String']>;
};

export type PriceModelDuration = {
  __typename?: 'PriceModelDuration';
  duration: Scalars['DurationString'];
  giftcards: Scalars['Boolean'];
  price: Scalars['Float'];
};

export type PriceModelDurationInput = {
  duration: Scalars['DurationString'];
  giftcards: Scalars['Boolean'];
  price: Scalars['Float'];
};

export type PriceModelInput = {
  cancellationWarranty?: InputMaybe<PriceModelWarrantyInput>;
  currency: Scalars['String'];
  default?: InputMaybe<Scalars['Boolean']>;
  defaultDurationBooking?: InputMaybe<Scalars['String']>;
  defaultDurationGiftcard?: InputMaybe<Scalars['String']>;
  dockingLocationZonePrices: Array<DockingLocationZonePriceInput>;
  durations: Array<PriceModelDurationInput>;
  giftcards?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shopId: Scalars['String'];
};

export type PriceModelWarranty = {
  __typename?: 'PriceModelWarranty';
  per?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type PriceModelWarrantyInput = {
  per: Scalars['String'];
  price: Scalars['Float'];
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imagePath?: Maybe<Scalars['String']>;
  localizedDescriptions: Localization;
  localizedNames: Localization;
  name: Scalars['String'];
  shopId: Scalars['ID'];
  ticketType: ProductTicketType;
};


export type ProductDescriptionArgs = {
  language: SupportedLanguage;
};


export type ProductNameArgs = {
  language: SupportedLanguage;
};

export enum ProductTicketType {
  PerPerson = 'PER_PERSON',
  WholeBoat = 'WHOLE_BOAT'
}

export type Query = {
  __typename?: 'Query';
  activeProducts: Array<Product>;
  activeWaiversByCountry: Array<Waiver>;
  adminNotificationRule: AdminNotificationRule;
  adminNotificationRules: Array<AdminNotificationRule>;
  adminNotificationRulesToMatchEvent: Array<AdminNotificationRule>;
  boat: Boat;
  bookingApiHealth: Scalars['Boolean'];
  bookingExtensionOptions: Array<BookingExtensionOption>;
  bookingHistoryLogs: PaginatedBookingHistoryLogs;
  communicationsApiHealth: Scalars['Boolean'];
  communicationsHistoryLogs: PaginatedCommunicationsHistoryLogs;
  countCustomerBookings: Scalars['Int'];
  dockingLocation: DockingLocation;
  featuredItem: FeaturedItem;
  featuredItems: Array<FeaturedItem>;
  getAdmin?: Maybe<Admin>;
  getAdmins: GetAdminsResult;
  getAndCountBookings: GetAndCountBookingsResult;
  getAndCountPayments: GetAndCountPaymentsResult;
  getBoat?: Maybe<Boat>;
  getBoats: Array<Boat>;
  getBoatsWithMetrics: Array<BoatWithMetrics>;
  getBooking: Booking;
  getBookingTrigger: BookingTrigger;
  getBookingTriggers: Array<BookingTrigger>;
  getBookingTriggersByShopId: Array<BookingTrigger>;
  getBookings: Array<Booking>;
  getBookingsById: Array<Booking>;
  getBookingsByReturnTime: Array<Booking>;
  getBusinessDay: BusinessDay;
  getBusinessDays: Array<BusinessDay>;
  getBusinessHours: Array<BusinessHours>;
  getCancellationPolicies: Array<CancellationPolicy>;
  getDockingLocationZonesByShopId: Array<DockingLocationZone>;
  getDockingLocationsByShopId: Array<DockingLocation>;
  getGiftCard: GiftCard;
  getIntegration?: Maybe<Integration>;
  getIntegrationProduct?: Maybe<IntegrationProduct>;
  getIntegrationProductsByBookingId: Array<IntegrationProduct>;
  getIntegrations: Array<Integration>;
  getMailchimpConfig?: Maybe<MailchimpConfig>;
  getMembership: Membership;
  getPayment: Payment;
  getPriceModels: Array<PriceModel>;
  getReceiptToken: ReceiptToken;
  getRoles: Array<Role>;
  getScheduledTextMessage: ScheduledTextMessage;
  getScheduledTextMessages: Array<ScheduledTextMessage>;
  getSelf?: Maybe<Admin>;
  getSendgridEmail: SendgridEmail;
  getSendgridEmailAttachment: SendgridEmailAttachment;
  getSendgridEmailAttachments: Array<SendgridEmailAttachment>;
  getSendgridEmails: Array<SendgridEmail>;
  getService?: Maybe<Service>;
  getServices: Array<Service>;
  getShop?: Maybe<Shop>;
  getShopBySlug?: Maybe<Shop>;
  getShopConfiguration?: Maybe<ShopConfiguration>;
  getShops: Array<Shop>;
  getSignedAttachmentUploadLink: SignedAttachmentUploadLinkResult;
  getTextMessagingSettings?: Maybe<TextMessagingSettings>;
  getTimeslots: Array<Timeslot>;
  getUspBannerEntries: Array<UspBannerEntry>;
  getVoucher: Voucher;
  getWaiver: Waiver;
  getWaiverBySlug: Waiver;
  getWaiverSubmission: WaiverSubmission;
  getWaiverVersion: WaiverVersion;
  getWaivers: Array<Waiver>;
  item: Item;
  itemCategories: Array<ItemCategory>;
  itemCategory: ItemCategory;
  items: PaginatedItems;
  previewScheduledTextMessage: Scalars['String'];
  products: Array<Product>;
  sendgridEmailsByType: Array<SendgridEmail>;
  unconvertedBookingSessions: Array<BookingSession>;
  waiverSubmissions: PaginatedWaiverSubmissions;
  waiversApiHealth: Scalars['Boolean'];
};


export type QueryActiveProductsArgs = {
  shopId: Scalars['ID'];
};


export type QueryActiveWaiversByCountryArgs = {
  country: Scalars['String'];
};


export type QueryAdminNotificationRuleArgs = {
  id: Scalars['ID'];
};


export type QueryAdminNotificationRulesArgs = {
  adminId: Scalars['ID'];
};


export type QueryAdminNotificationRulesToMatchEventArgs = {
  event: NotificationEvent;
  hoursToSailout: Scalars['Float'];
  shopId: Scalars['ID'];
  source: BookingSource;
};


export type QueryBoatArgs = {
  externalId?: InputMaybe<Scalars['String']>;
};


export type QueryBookingExtensionOptionsArgs = {
  bookingId: Scalars['String'];
};


export type QueryBookingHistoryLogsArgs = {
  id: Scalars['String'];
  relation: BookingHistoryLogRelation;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunicationsHistoryLogsArgs = {
  id: Scalars['String'];
  relation: CommunicationsHistoryLogRelation;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCountCustomerBookingsArgs = {
  email: Scalars['String'];
};


export type QueryDockingLocationArgs = {
  id: Scalars['ID'];
};


export type QueryFeaturedItemArgs = {
  id: Scalars['String'];
};


export type QueryFeaturedItemsArgs = {
  shopId: Scalars['String'];
  types?: InputMaybe<Array<FeaturedItemType>>;
};


export type QueryGetAdminArgs = {
  id: Scalars['String'];
};


export type QueryGetAdminsArgs = {
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  shopIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAndCountBookingsArgs = {
  after?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<SortOptions>>;
  shopId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<BookingStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAndCountPaymentsArgs = {
  shopId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBoatArgs = {
  id: Scalars['String'];
};


export type QueryGetBoatsArgs = {
  excludeOccupied?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
  statuses?: InputMaybe<Array<BoatStatus>>;
};


export type QueryGetBoatsWithMetricsArgs = {
  shopId: Scalars['String'];
};


export type QueryGetBookingArgs = {
  id: Scalars['String'];
};


export type QueryGetBookingTriggerArgs = {
  id: Scalars['String'];
};


export type QueryGetBookingTriggersByShopIdArgs = {
  shopId: Scalars['String'];
};


export type QueryGetBookingsArgs = {
  after?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Date']>;
  orderBy?: InputMaybe<Array<SortOptions>>;
  shopIds?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<BookingStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBookingsByIdArgs = {
  bookingIds: Array<Scalars['String']>;
};


export type QueryGetBookingsByReturnTimeArgs = {
  returnTime: Scalars['Date'];
  shopId: Scalars['String'];
};


export type QueryGetBusinessDayArgs = {
  date: Scalars['Date'];
  shopId: Scalars['String'];
};


export type QueryGetBusinessDaysArgs = {
  after: Scalars['Date'];
  before: Scalars['Date'];
  shopId: Scalars['String'];
};


export type QueryGetBusinessHoursArgs = {
  after?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Date']>;
  shopId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortOrder>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCancellationPoliciesArgs = {
  shopId: Scalars['String'];
};


export type QueryGetDockingLocationZonesByShopIdArgs = {
  shopId: Scalars['String'];
};


export type QueryGetDockingLocationsByShopIdArgs = {
  shopId: Scalars['String'];
};


export type QueryGetGiftCardArgs = {
  id: Scalars['String'];
};


export type QueryGetIntegrationArgs = {
  id: Scalars['String'];
};


export type QueryGetIntegrationProductArgs = {
  id: Scalars['String'];
};


export type QueryGetIntegrationProductsByBookingIdArgs = {
  bookingId: Scalars['String'];
  serviceName: Scalars['String'];
};


export type QueryGetMailchimpConfigArgs = {
  shopId: Scalars['String'];
};


export type QueryGetMembershipArgs = {
  id: Scalars['String'];
};


export type QueryGetPaymentArgs = {
  id: Scalars['String'];
};


export type QueryGetPriceModelsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
};


export type QueryGetReceiptTokenArgs = {
  id: Scalars['String'];
};


export type QueryGetRolesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetScheduledTextMessageArgs = {
  id: Scalars['String'];
};


export type QueryGetScheduledTextMessagesArgs = {
  shopId: Scalars['String'];
};


export type QueryGetSendgridEmailArgs = {
  id: Scalars['String'];
};


export type QueryGetSendgridEmailAttachmentArgs = {
  id: Scalars['String'];
};


export type QueryGetSendgridEmailAttachmentsArgs = {
  country: Scalars['String'];
};


export type QueryGetSendgridEmailsArgs = {
  shopId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetServiceArgs = {
  id: Scalars['String'];
};


export type QueryGetShopArgs = {
  id: Scalars['String'];
};


export type QueryGetShopBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetShopConfigurationArgs = {
  shopId: Scalars['String'];
};


export type QueryGetShopsArgs = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
};


export type QueryGetSignedAttachmentUploadLinkArgs = {
  filename: Scalars['String'];
  shopId: Scalars['String'];
};


export type QueryGetTextMessagingSettingsArgs = {
  shopId: Scalars['String'];
};


export type QueryGetTimeslotsArgs = {
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  excludeBookingId?: InputMaybe<Scalars['String']>;
  excludeInvalidSailoutTimes?: InputMaybe<Scalars['Boolean']>;
  excludeReservations?: InputMaybe<Scalars['Boolean']>;
  fromDate: Scalars['Date'];
  integration?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<SupportedLanguage>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  toDate: Scalars['Date'];
  useCache?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetUspBannerEntriesArgs = {
  language: SupportedLanguage;
  shopId: Scalars['String'];
};


export type QueryGetVoucherArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiverArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiverBySlugArgs = {
  shopId: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryGetWaiverSubmissionArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiverVersionArgs = {
  id: Scalars['String'];
};


export type QueryGetWaiversArgs = {
  shopId: Scalars['String'];
};


export type QueryItemArgs = {
  id: Scalars['String'];
};


export type QueryItemCategoriesArgs = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  shopId: Scalars['String'];
};


export type QueryItemCategoryArgs = {
  id: Scalars['String'];
};


export type QueryItemsArgs = {
  shopId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<ItemStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPreviewScheduledTextMessageArgs = {
  bookingId: Scalars['String'];
  scheduledTextMessageId: Scalars['String'];
};


export type QueryProductsArgs = {
  shopId: Scalars['ID'];
};


export type QuerySendgridEmailsByTypeArgs = {
  type: Scalars['String'];
};


export type QueryUnconvertedBookingSessionsArgs = {
  lang?: InputMaybe<SupportedLanguage>;
  lastActivityAfter: Scalars['Date'];
  lastActivityBefore: Scalars['Date'];
  shopId: Scalars['ID'];
};


export type QueryWaiverSubmissionsArgs = {
  id: Scalars['String'];
  relation: WaiverSubmissionRelation;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ReceiptToken = {
  __typename?: 'ReceiptToken';
  entityId: Scalars['String'];
  expires: Scalars['Date'];
  id: Scalars['String'];
  type: ReceiptTokenType;
  userId: Scalars['String'];
};

export enum ReceiptTokenType {
  Booking = 'booking',
  GiftCard = 'giftCard',
  Membership = 'membership'
}

export type RecordSessionActivityInput = {
  bookingId?: InputMaybe<Scalars['ID']>;
  currentStep: BookingStep;
  email?: InputMaybe<Scalars['String']>;
  lang: SupportedLanguage;
  reservationId?: InputMaybe<Scalars['ID']>;
  sessionUuid: Scalars['ID'];
  shopId?: InputMaybe<Scalars['ID']>;
};

export type RefreshBookingReservationResult = {
  __typename?: 'RefreshBookingReservationResult';
  booking: Booking;
  forfeitItems: Array<Item>;
  success: Scalars['Boolean'];
  suggestedTimeslot?: Maybe<Scalars['Date']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  boatCount: Scalars['Int'];
  bookingId: Scalars['String'];
  createdDate: Scalars['Date'];
  date: Scalars['Date'];
  dropoffLocationId?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  endTime: Scalars['String'];
  expires: Scalars['Date'];
  id: Scalars['String'];
  itemReservations: Array<ItemReservation>;
  modifiedDate: Scalars['Date'];
  pickupLocationId?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  priceBreakdown: BookingPriceBreakdown;
  shopId: Scalars['String'];
  startTime: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['String'];
  name: RoleName;
};

export enum RoleName {
  Admin = 'Admin',
  Crew = 'Crew',
  Reseller = 'Reseller',
  SuperAdmin = 'SuperAdmin',
  System = 'System'
}

export type ScheduledTextMessage = {
  __typename?: 'ScheduledTextMessage';
  body: Scalars['String'];
  bookingConditions: ScheduledTextMessageBookingConditions;
  bookingTriggerIds: Array<Scalars['String']>;
  bookingTriggers: Array<BookingTrigger>;
  cooldownMinutes: Scalars['Int'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  shopId: Scalars['String'];
};

export type ScheduledTextMessageBookingConditions = {
  __typename?: 'ScheduledTextMessageBookingConditions';
  canExtend: BooleanCondition;
  languages: Array<SupportedLanguage>;
  missingWaiverSignatures: BooleanCondition;
  resellerBooking: BooleanCondition;
};

export type ScheduledTextMessageBookingConditionsInput = {
  canExtend: BooleanCondition;
  languages: Array<SupportedLanguage>;
  missingWaiverSignatures: BooleanCondition;
  resellerBooking: BooleanCondition;
};

export type ScheduledTextMessageInput = {
  body: Scalars['String'];
  bookingConditions: ScheduledTextMessageBookingConditionsInput;
  bookingTriggerIds: Array<Scalars['String']>;
  cooldownMinutes: Scalars['Int'];
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SendgridConfig = {
  __typename?: 'SendgridConfig';
  apiKey: Scalars['String'];
  id: Scalars['String'];
  shopId: Scalars['String'];
};

export type SendgridEmail = {
  __typename?: 'SendgridEmail';
  attachments: Array<SendgridEmailAttachment>;
  conditions: SendgridEmailConditions;
  enabled: Scalars['Boolean'];
  from: Scalars['String'];
  hasOldAttachments: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  oldAttachments: Array<OldAttachment>;
  options?: Maybe<SendgridEmailOptions>;
  shopId: Scalars['String'];
  templateId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailAttachment = {
  __typename?: 'SendgridEmailAttachment';
  country: Scalars['String'];
  emails: Array<SendgridEmail>;
  filename: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  personalization?: Maybe<SendgridEmailPersonalizationConfiguration>;
  shopId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailAttachmentInput = {
  country: Scalars['String'];
  filename: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  personalization?: InputMaybe<SendgridEmailPersonalizationConfigurationInput>;
  shopId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailConditions = {
  __typename?: 'SendgridEmailConditions';
  booking_lang?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  lang?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  waiverId?: Maybe<Scalars['String']>;
};

export type SendgridEmailConditionsInput = {
  booking_lang?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  lang?: InputMaybe<Scalars['String']>;
  plan_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  waiverId?: InputMaybe<Scalars['String']>;
};

export type SendgridEmailInput = {
  conditions: SendgridEmailConditionsInput;
  enabled: Scalars['Boolean'];
  from: Scalars['String'];
  name: Scalars['String'];
  options: SendgridEmailOptionsInput;
  shopId: Scalars['String'];
  templateId: Scalars['String'];
  type: Scalars['String'];
};

export type SendgridEmailOptions = {
  __typename?: 'SendgridEmailOptions';
  campaignText?: Maybe<Scalars['String']>;
  displayCampaignText?: Maybe<Scalars['Boolean']>;
  emailCopyAddress?: Maybe<Scalars['String']>;
  getEmailCopy?: Maybe<Scalars['Boolean']>;
  receipt?: Maybe<Scalars['Boolean']>;
};

export type SendgridEmailOptionsInput = {
  campaignText?: InputMaybe<Scalars['String']>;
  displayCampaignText?: InputMaybe<Scalars['Boolean']>;
  emailCopyAddress?: InputMaybe<Scalars['String']>;
  getEmailCopy?: InputMaybe<Scalars['Boolean']>;
  receipt?: InputMaybe<Scalars['Boolean']>;
};

export type SendgridEmailPersonalizationConfiguration = {
  __typename?: 'SendgridEmailPersonalizationConfiguration';
  campaignText?: Maybe<AttachmentPersonalization>;
  code?: Maybe<AttachmentPersonalization>;
  duration?: Maybe<AttachmentPersonalization>;
  expires?: Maybe<AttachmentPersonalization>;
  name?: Maybe<AttachmentPersonalization>;
  price?: Maybe<AttachmentPersonalization>;
  shop?: Maybe<AttachmentPersonalization>;
  value?: Maybe<AttachmentPersonalization>;
};

export type SendgridEmailPersonalizationConfigurationInput = {
  campaignText?: InputMaybe<AttachmentPersonalizationInput>;
  code?: InputMaybe<AttachmentPersonalizationInput>;
  duration?: InputMaybe<AttachmentPersonalizationInput>;
  expires?: InputMaybe<AttachmentPersonalizationInput>;
  name?: InputMaybe<AttachmentPersonalizationInput>;
  price?: InputMaybe<AttachmentPersonalizationInput>;
  shop?: InputMaybe<AttachmentPersonalizationInput>;
  value?: InputMaybe<AttachmentPersonalizationInput>;
};

export type Service = {
  __typename?: 'Service';
  createdDate?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  fields: Array<ServiceField>;
  id: Scalars['String'];
  integrations: Array<Integration>;
  modifiedDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  type: ServiceType;
};

export type ServiceField = {
  __typename?: 'ServiceField';
  key: Scalars['String'];
  type: Scalars['String'];
};

export type ServiceFieldInput = {
  key: Scalars['String'];
  type: Scalars['String'];
};

export enum ServiceType {
  Analytics = 'Analytics',
  BoatTracking = 'BoatTracking',
  Emails = 'Emails',
  Newsletter = 'Newsletter',
  Payment = 'Payment',
  Reporting = 'Reporting',
  Reseller = 'Reseller',
  Waivers = 'Waivers'
}

export type Shop = {
  __typename?: 'Shop';
  activeItems: Array<Item>;
  activeProducts: Array<Product>;
  activeWaivers: Array<Waiver>;
  address: ShopAddress;
  adminRoot: Scalars['String'];
  bookingLocalizations?: Maybe<BookingLocalizations>;
  bookingRoot: Scalars['String'];
  cancellationPolicies: Array<CancellationPolicy>;
  configuration?: Maybe<ShopConfiguration>;
  country: Scalars['String'];
  countryCode: Scalars['String'];
  currency: Scalars['String'];
  defaultDuration?: Maybe<Scalars['String']>;
  defaultGiftcardDuration?: Maybe<Scalars['String']>;
  dockingLocationZones: Array<DockingLocationZone>;
  dockingLocations: Array<DockingLocation>;
  durationOptions: Array<BusinessDayDuration>;
  featureFlags: Array<FeatureFlag>;
  giftCardLocalizations?: Maybe<GiftCardLocalizations>;
  giftcardDurationOptions: Array<GiftcardDuration>;
  hasActiveItems: Scalars['Boolean'];
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  integrations: Array<Integration>;
  items: Array<Item>;
  location: Location;
  main?: Maybe<Scalars['Boolean']>;
  maxBoatCount: Scalars['Int'];
  name: Scalars['String'];
  priceModels: Array<PriceModel>;
  products: Array<Product>;
  scheduledTextMessages: Array<ScheduledTextMessage>;
  sendgridConfig?: Maybe<SendgridConfig>;
  sendgridEmails: Array<SendgridEmail>;
  shopSettings?: Maybe<ShopSettings>;
  showNewsletterSignup: Scalars['Boolean'];
  slug: Scalars['String'];
  taxRate: Scalars['Int'];
  textMessagingSettings?: Maybe<TextMessagingSettings>;
  timezoneName: Scalars['String'];
  uspBannerEntries: Array<UspBannerEntry>;
  waivers: Array<Waiver>;
  warrantyFromPrice: Scalars['Float'];
  website: Scalars['String'];
  websiteRoot: Scalars['String'];
};


export type ShopSendgridEmailsArgs = {
  type?: InputMaybe<Scalars['String']>;
};

export type ShopAddress = {
  __typename?: 'ShopAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  cvr: Scalars['String'];
  format: Scalars['String'];
  recipient: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type ShopConfiguration = {
  __typename?: 'ShopConfiguration';
  enableCustomAmountGiftCards?: Maybe<Scalars['Boolean']>;
  enableServerSideTracking?: Maybe<Scalars['Boolean']>;
  flagLateReturns?: Maybe<Scalars['Boolean']>;
  giftCardValidForExtras?: Maybe<Scalars['Boolean']>;
  giftcardValidity?: Maybe<Scalars['Int']>;
  gtmId?: Maybe<Scalars['String']>;
  hideGiftCardDurations?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  instructionsRulesUrls?: Maybe<Localization>;
  lowAvailabilityAlertThreshold?: Maybe<Scalars['Int']>;
  minimumTimeBetweenBookings?: Maybe<Scalars['Int']>;
  modifiedDate: Scalars['Date'];
  /** @deprecated Use localized paymentSuccessUrls instead */
  paymentSuccessUrl?: Maybe<Scalars['String']>;
  paymentSuccessUrls?: Maybe<Localization>;
  pixelId?: Maybe<Scalars['String']>;
  preSelectNewsletter?: Maybe<Scalars['Boolean']>;
  refundVoucherValidForExtras?: Maybe<Scalars['Boolean']>;
  refundVoucherValidity?: Maybe<Scalars['Int']>;
  routesSightseeingUrls?: Maybe<Localization>;
  shopId: Scalars['String'];
  stripePublicKey?: Maybe<Scalars['String']>;
  termsUrl?: Maybe<Scalars['String']>;
  useCustomPaymentConfirmationPage?: Maybe<Scalars['Boolean']>;
  waiversWebsite?: Maybe<Scalars['String']>;
};

export type ShopConfigurationInput = {
  enableCustomAmountGiftCards?: InputMaybe<Scalars['Boolean']>;
  enableServerSideTracking?: InputMaybe<Scalars['Boolean']>;
  flagLateReturns?: InputMaybe<Scalars['Boolean']>;
  giftCardValidForExtras?: InputMaybe<Scalars['Boolean']>;
  giftcardValidity?: InputMaybe<Scalars['Int']>;
  gtmId?: InputMaybe<Scalars['String']>;
  hideGiftCardDurations?: InputMaybe<Scalars['Boolean']>;
  instructionsRulesUrls?: InputMaybe<LocalizationInput>;
  lowAvailabilityAlertThreshold?: InputMaybe<Scalars['Int']>;
  minimumTimeBetweenBookings?: InputMaybe<Scalars['Int']>;
  paymentSuccessUrl?: InputMaybe<Scalars['String']>;
  paymentSuccessUrls?: InputMaybe<LocalizationInput>;
  pixelId?: InputMaybe<Scalars['String']>;
  preSelectNewsletter?: InputMaybe<Scalars['Boolean']>;
  refundVoucherValidForExtras?: InputMaybe<Scalars['Boolean']>;
  refundVoucherValidity?: InputMaybe<Scalars['Int']>;
  routesSightseeingUrls?: InputMaybe<LocalizationInput>;
  stripePublicKey?: InputMaybe<Scalars['String']>;
  termsUrl?: InputMaybe<Scalars['String']>;
  useCustomPaymentConfirmationPage?: InputMaybe<Scalars['Boolean']>;
  waiversWebsite?: InputMaybe<Scalars['String']>;
};

export type ShopSettings = {
  __typename?: 'ShopSettings';
  booking: ShopSettingsBooking;
  giftcard?: Maybe<ShopSettingsGiftcard>;
  id: Scalars['String'];
  membership?: Maybe<ShopSettingsMembership>;
  receipt?: Maybe<ShopSettingsReceipt>;
};

export type ShopSettingsBooking = {
  __typename?: 'ShopSettingsBooking';
  calendarHelpText?: Maybe<ShopSettingsBookingCalendarHelpText>;
  itemsPerPage?: Maybe<Scalars['Int']>;
  newsletterText?: Maybe<ShopSettingsBookingNewsletterText>;
  refundVoucherValidity?: Maybe<Scalars['Int']>;
  termsLink?: Maybe<ShopSettingsBookingTermsLink>;
  termsText?: Maybe<ShopSettingsBookingTermsText>;
};

export type ShopSettingsBookingCalendarHelpText = {
  __typename?: 'ShopSettingsBookingCalendarHelpText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsBookingInput = {
  paymentSuccessShowEmail: Scalars['Boolean'];
  refundVoucherValidity: Scalars['Int'];
};

export type ShopSettingsBookingNewsletterText = {
  __typename?: 'ShopSettingsBookingNewsletterText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsBookingTermsLink = {
  __typename?: 'ShopSettingsBookingTermsLink';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsBookingTermsText = {
  __typename?: 'ShopSettingsBookingTermsText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcard = {
  __typename?: 'ShopSettingsGiftcard';
  faq?: Maybe<Scalars['Boolean']>;
  introText?: Maybe<ShopSettingsGiftcardIntroText>;
  paymentSuccessLink?: Maybe<ShopSettingsGiftcardPaymentSuccessLink>;
  paymentSuccessShowEmail?: Maybe<Scalars['Boolean']>;
  paymentSuccessText?: Maybe<ShopSettingsGiftcardPaymentSuccessText>;
  questions?: Maybe<ShopSettingsGiftcardFaqQuestions>;
  validity?: Maybe<Scalars['Int']>;
};

export type ShopSettingsGiftcardFaqQuestion = {
  __typename?: 'ShopSettingsGiftcardFaqQuestion';
  answer?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcardFaqQuestions = {
  __typename?: 'ShopSettingsGiftcardFaqQuestions';
  da?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
  de?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
  en?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
  sv?: Maybe<Array<Maybe<ShopSettingsGiftcardFaqQuestion>>>;
};

export type ShopSettingsGiftcardIntroText = {
  __typename?: 'ShopSettingsGiftcardIntroText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcardPaymentSuccessLink = {
  __typename?: 'ShopSettingsGiftcardPaymentSuccessLink';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsGiftcardPaymentSuccessText = {
  __typename?: 'ShopSettingsGiftcardPaymentSuccessText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsInput = {
  booking: ShopSettingsBookingInput;
};

export type ShopSettingsMembership = {
  __typename?: 'ShopSettingsMembership';
  paymentSuccessLink?: Maybe<ShopSettingsMembershipPaymentSuccessLink>;
  paymentSuccessText?: Maybe<ShopSettingsMembershipPaymentSuccessText>;
};

export type ShopSettingsMembershipPaymentSuccessLink = {
  __typename?: 'ShopSettingsMembershipPaymentSuccessLink';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsMembershipPaymentSuccessText = {
  __typename?: 'ShopSettingsMembershipPaymentSuccessText';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsReceipt = {
  __typename?: 'ShopSettingsReceipt';
  taxName?: Maybe<ShopSettingsReceiptTaxName>;
  title?: Maybe<ShopSettingsReceiptTitle>;
};

export type ShopSettingsReceiptTaxName = {
  __typename?: 'ShopSettingsReceiptTaxName';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type ShopSettingsReceiptTitle = {
  __typename?: 'ShopSettingsReceiptTitle';
  da?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  sv?: Maybe<Scalars['String']>;
};

export type SignatureInput = {
  agreements?: InputMaybe<Array<AgreementInput>>;
  data: WaiverData;
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  minors?: InputMaybe<Array<MinorSignatureInput>>;
};

export type SignedAttachmentUploadLinkResult = {
  __typename?: 'SignedAttachmentUploadLinkResult';
  filename: Scalars['String'];
  link: Scalars['String'];
};

export type SortOptions = {
  field: Scalars['String'];
  order: SortOrder;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SunTimes = {
  __typename?: 'SunTimes';
  sunrise: Scalars['Date'];
  sunset: Scalars['Date'];
};

export enum SupportedLanguage {
  Da = 'da',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Sv = 'sv'
}

export type TextMessage = {
  __typename?: 'TextMessage';
  body: Scalars['String'];
  bookingId: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  status: TextMessageStatus;
  to: Scalars['String'];
};

export enum TextMessageStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Delivered = 'delivered',
  Failed = 'failed',
  PartiallyDelivered = 'partially_delivered',
  Queued = 'queued',
  Read = 'read',
  Received = 'received',
  Receiving = 'receiving',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent',
  Undelivered = 'undelivered'
}

export type TextMessagingSettings = {
  __typename?: 'TextMessagingSettings';
  allowCrewCustomMessages: Scalars['Boolean'];
  allowCrewTemplateMessages: Scalars['Boolean'];
  id: Scalars['String'];
  shopId: Scalars['String'];
  twilioAccountSid?: Maybe<Scalars['String']>;
  twilioAuthToken?: Maybe<Scalars['String']>;
  twilioMessagingServiceSid?: Maybe<Scalars['String']>;
};

export type TextMessagingSettingsInput = {
  allowCrewCustomMessages: Scalars['Boolean'];
  allowCrewTemplateMessages: Scalars['Boolean'];
  twilioAccountSid?: InputMaybe<Scalars['String']>;
  twilioAuthToken?: InputMaybe<Scalars['String']>;
  twilioMessagingServiceSid?: InputMaybe<Scalars['String']>;
};

export enum TimeWindow {
  Anytime = 'ANYTIME',
  SameDay = 'SAME_DAY',
  WithinHours = 'WITHIN_HOURS'
}

export type Timeslot = {
  __typename?: 'Timeslot';
  availableToIntegrations: Scalars['Boolean'];
  bookableBoats: Scalars['Int'];
  customerFacingText?: Maybe<Scalars['String']>;
  dateTime: Scalars['Date'];
  isBlockedByMinimumNotice?: Maybe<Scalars['Boolean']>;
  isValidSailoutTime?: Maybe<Scalars['Boolean']>;
  maxConcurrent: Scalars['Int'];
  priceModel: PriceModel;
  priceModelId: Scalars['String'];
  returning: Scalars['Int'];
  sailouts: Scalars['Int'];
  totalSailing: Scalars['Int'];
  vacancies: Array<Vacancy>;
};

export type UpdateAdminInput = {
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UspBannerEntry = {
  __typename?: 'UspBannerEntry';
  id: Scalars['String'];
  index: Scalars['Int'];
  language: SupportedLanguage;
  modifiedDate: Scalars['String'];
  shopId: Scalars['String'];
  text: Scalars['String'];
};

export type UspBannerInput = {
  index: Scalars['Int'];
  text: Scalars['String'];
};

export type Vacancy = {
  __typename?: 'Vacancy';
  duration: Scalars['DurationString'];
  integrationVacancies: Scalars['Int'];
  price: Scalars['Int'];
  vacancies: Scalars['Int'];
};

export enum View {
  Internal = 'internal',
  Postbook = 'postbook',
  Prebook = 'prebook',
  Website = 'website'
}

export type Voucher = {
  __typename?: 'Voucher';
  category?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdDate?: Maybe<Scalars['Date']>;
  creator?: Maybe<Scalars['String']>;
  days: Array<VoucherDailyValidity>;
  description: Scalars['String'];
  discountedCategories: Array<ItemCategory>;
  discountedItemIds: Array<Scalars['String']>;
  discountedItems: Array<Item>;
  expires: Scalars['Date'];
  id: Scalars['String'];
  maxUsage?: Maybe<Scalars['Boolean']>;
  modifiedDate?: Maybe<Scalars['Date']>;
  shopId: Scalars['String'];
  start?: Maybe<Scalars['Date']>;
  type: VoucherType;
  usageLimit?: Maybe<Scalars['Int']>;
  uses: Scalars['Int'];
  validFor: Array<VoucherValidFor>;
  validFromTime?: Maybe<Scalars['String']>;
  validUntilTime?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

export type VoucherDailyValidity = {
  __typename?: 'VoucherDailyValidity';
  valid: Scalars['Boolean'];
  weekday: CapitalizedWeekday;
};

export enum VoucherType {
  Flat = 'flat',
  Percent = 'percent'
}

export enum VoucherValidFor {
  Booking = 'booking',
  Extras = 'extras',
  Giftcard = 'giftcard',
  Membership = 'membership'
}

export enum VoucherValidityError {
  VoucherAlreadyAdded = 'VoucherAlreadyAdded',
  VoucherCategoryInvalid = 'VoucherCategoryInvalid',
  VoucherDateInvalid = 'VoucherDateInvalid',
  VoucherDepleted = 'VoucherDepleted',
  VoucherInvalid = 'VoucherInvalid',
  VoucherItemInvalid = 'VoucherItemInvalid',
  VoucherLocationInvalid = 'VoucherLocationInvalid',
  VoucherTimeInvalid = 'VoucherTimeInvalid',
  VoucherValidForInvalid = 'VoucherValidForInvalid',
  VoucherWeekdayInvalid = 'VoucherWeekdayInvalid'
}

export type Waiver = {
  __typename?: 'Waiver';
  active: Scalars['Boolean'];
  activeVersions: Array<WaiverVersion>;
  archived: Scalars['Boolean'];
  historyLogs: Array<WaiverHistoryLog>;
  id: Scalars['String'];
  name: Scalars['String'];
  shopId: Scalars['String'];
  slug: Scalars['String'];
  type: WaiverType;
  versions: Array<WaiverVersion>;
};

export type WaiverData = {
  birthDate?: InputMaybe<Scalars['Date']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  italianFiscalCode?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type WaiverHistoryLog = {
  __typename?: 'WaiverHistoryLog';
  createdDate: Scalars['Date'];
  event: Scalars['String'];
  id: Scalars['String'];
  meta: Scalars['JSON'];
  subjectAdminId?: Maybe<Scalars['String']>;
  waiverId?: Maybe<Scalars['String']>;
  waiverVersionId?: Maybe<Scalars['String']>;
  who?: Maybe<HistoryLogWho>;
};

export type WaiverInput = {
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  name: Scalars['String'];
  shopId: Scalars['String'];
  type: WaiverType;
};

export type WaiverSubmission = {
  __typename?: 'WaiverSubmission';
  agreements: Array<Agreement>;
  birthDate?: Maybe<Scalars['Date']>;
  bookingId: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdDate: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  italianFiscalCode?: Maybe<Scalars['String']>;
  minors: Array<MinorSignature>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  waiver: Waiver;
  waiverId: Scalars['String'];
  waiverVersion: WaiverVersion;
  waiverVersionId: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export enum WaiverSubmissionRelation {
  BookingId = 'bookingId'
}

export enum WaiverType {
  Dock = 'DOCK',
  Online = 'ONLINE'
}

export type WaiverVersion = {
  __typename?: 'WaiverVersion';
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  checkboxes: Array<WaiverVersionCheckbox>;
  confirmationPage: Scalars['String'];
  content: Scalars['String'];
  disableMinorSignatures: Scalars['Boolean'];
  fields: WaiverVersionFields;
  id: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
  newsletterSignupText?: Maybe<Scalars['String']>;
  preSelectNewsletterSignup?: Maybe<Scalars['Boolean']>;
  pristine: Scalars['Boolean'];
  requireMinorBirthDate: Scalars['Boolean'];
  sharing: WaiverVersionSharing;
  showNewsletterSignup?: Maybe<Scalars['Boolean']>;
  waiver: Waiver;
  waiverId: Scalars['String'];
};

export type WaiverVersionCheckbox = {
  __typename?: 'WaiverVersionCheckbox';
  name: Scalars['String'];
  omitInPrint: Scalars['Boolean'];
  signature: Scalars['Boolean'];
  text: Scalars['String'];
};

export type WaiverVersionCheckboxInput = {
  name: Scalars['String'];
  omitInPrint: Scalars['Boolean'];
  signature: Scalars['Boolean'];
  text: Scalars['String'];
};

export type WaiverVersionFields = {
  __typename?: 'WaiverVersionFields';
  birthDate: Scalars['Boolean'];
  city: Scalars['Boolean'];
  country: Scalars['Boolean'];
  email: Scalars['Boolean'];
  italianFiscalCode: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  state: Scalars['Boolean'];
  streetAddress: Scalars['Boolean'];
  zip: Scalars['Boolean'];
};

export type WaiverVersionFieldsInput = {
  birthDate: Scalars['Boolean'];
  city: Scalars['Boolean'];
  country: Scalars['Boolean'];
  email: Scalars['Boolean'];
  italianFiscalCode: Scalars['Boolean'];
  phone: Scalars['Boolean'];
  state: Scalars['Boolean'];
  streetAddress: Scalars['Boolean'];
  zip: Scalars['Boolean'];
};

export type WaiverVersionInput = {
  checkboxes: Array<WaiverVersionCheckboxInput>;
  confirmationPage: Scalars['String'];
  content: Scalars['String'];
  disableMinorSignatures: Scalars['Boolean'];
  fields: WaiverVersionFieldsInput;
  language: Scalars['String'];
  name: Scalars['String'];
  newsletterSignupText?: InputMaybe<Scalars['String']>;
  preSelectNewsletterSignup?: InputMaybe<Scalars['Boolean']>;
  requireMinorBirthDate: Scalars['Boolean'];
  sharing: WaiverVersionSharingInput;
  showNewsletterSignup?: InputMaybe<Scalars['Boolean']>;
  waiverId: Scalars['String'];
};

export type WaiverVersionSharing = {
  __typename?: 'WaiverVersionSharing';
  buttonText: Scalars['String'];
  enabled: Scalars['Boolean'];
  heading: Scalars['String'];
  text: Scalars['String'];
};

export type WaiverVersionSharingInput = {
  buttonText: Scalars['String'];
  enabled: Scalars['Boolean'];
  heading: Scalars['String'];
  text: Scalars['String'];
};

export type Booking_UltraMinimalShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, hidden?: boolean | null };

export type Booking_MinimalShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, hidden?: boolean | null, maxBoatCount: number, country: string, currency: string, defaultDuration?: string | null, hasActiveItems: boolean, mailchimp: boolean, durationOptions: Array<{ __typename?: 'BusinessDayDuration', priceLow: number, priceHigh: number, durationNumber: number, durationString: any }>, activeProducts: Array<{ __typename?: 'Product', id: string, name: string }> };

export type Booking_ShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, timezoneName: string, main?: boolean | null, website: string, websiteRoot: string, warrantyFromPrice: number, shopSettings?: { __typename?: 'ShopSettings', booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, preSelectNewsletter?: boolean | null, lowAvailabilityAlertThreshold?: number | null, useCustomPaymentConfirmationPage?: boolean | null, enableServerSideTracking?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', id: string, name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, currency: string, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, order?: number | null, name: string, trackingName: string, shortDescription?: string | null, description?: string | null, stock: number, price: number, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, categoryNames: Array<string>, displayedOn: Array<View>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, alcoholUnits?: number | null, rentalItem?: boolean | null, rentalStock?: number | null, imagepath?: string | null, days: Array<{ __typename?: 'ItemDays', weekday: string, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null };

export type Booking_GetMinimalShopQueryVariables = Exact<{
  shopId: Scalars['String'];
  language: SupportedLanguage;
}>;


export type Booking_GetMinimalShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name: string, hidden?: boolean | null, maxBoatCount: number, country: string, currency: string, defaultDuration?: string | null, hasActiveItems: boolean, mailchimp: boolean, durationOptions: Array<{ __typename?: 'BusinessDayDuration', priceLow: number, priceHigh: number, durationNumber: number, durationString: any }>, activeProducts: Array<{ __typename?: 'Product', id: string, name: string }> } | null };

export type Booking_GetMinimalShopsQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
}>;


export type Booking_GetMinimalShopsQuery = { __typename?: 'Query', getShops: Array<{ __typename?: 'Shop', id: string, name: string, hidden?: boolean | null }> };

export type Booking_GetShopQueryVariables = Exact<{
  shopId: Scalars['String'];
  language: SupportedLanguage;
}>;


export type Booking_GetShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name: string, timezoneName: string, main?: boolean | null, website: string, websiteRoot: string, warrantyFromPrice: number, shopSettings?: { __typename?: 'ShopSettings', booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, preSelectNewsletter?: boolean | null, lowAvailabilityAlertThreshold?: number | null, useCustomPaymentConfirmationPage?: boolean | null, enableServerSideTracking?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', id: string, name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, currency: string, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, order?: number | null, name: string, trackingName: string, shortDescription?: string | null, description?: string | null, stock: number, price: number, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, categoryNames: Array<string>, displayedOn: Array<View>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, alcoholUnits?: number | null, rentalItem?: boolean | null, rentalStock?: number | null, imagepath?: string | null, days: Array<{ __typename?: 'ItemDays', weekday: string, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null } | null };

export type Booking_InitiatePaymentCreateBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  clientPrice: Scalars['Int'];
  subscribeToNewsletter: Scalars['Boolean'];
}>;


export type Booking_InitiatePaymentCreateBookingMutation = { __typename?: 'Mutation', initiatePaymentCreateBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type Booking_EditBookingMutationVariables = Exact<{
  id: Scalars['String'];
  boatCount: Scalars['Int'];
  duration: Scalars['Float'];
  date: Scalars['Date'];
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  forfeitVouchers?: InputMaybe<Scalars['Boolean']>;
  forfeitRentalItems?: InputMaybe<Scalars['Boolean']>;
}>;


export type Booking_EditBookingMutation = { __typename?: 'Mutation', editBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type Booking_AddCancellationWarrantyMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type Booking_AddCancellationWarrantyMutation = { __typename?: 'Mutation', addCancellationWarranty: { __typename?: 'Booking', id: string, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string } | null, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type Booking_UpdateCustomerMutationVariables = Exact<{
  id: Scalars['String'];
  input: CustomerInput;
}>;


export type Booking_UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id: string } };

export type Booking_UpdateAndValidateCustomerMutationVariables = Exact<{
  id: Scalars['String'];
  input: CustomerInput;
}>;


export type Booking_UpdateAndValidateCustomerMutation = { __typename?: 'Mutation', updateAndValidateCustomer: { __typename?: 'Customer', id: string } };

export type Booking_ReserveMutationVariables = Exact<{
  date: Scalars['Date'];
  duration: Scalars['Float'];
  boatCount: Scalars['Int'];
  productId: Scalars['ID'];
  customer: CustomerInput;
  lang: SupportedLanguage;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  includeWarranty: Scalars['Boolean'];
}>;


export type Booking_ReserveMutation = { __typename?: 'Mutation', reserve: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type Booking_CreateBookingPaymentIntentMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type Booking_CreateBookingPaymentIntentMutation = { __typename?: 'Mutation', createBookingPaymentIntent: string };

export type Booking_ConfirmBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  subToNewsletter?: InputMaybe<Scalars['Boolean']>;
}>;


export type Booking_ConfirmBookingMutation = { __typename?: 'Mutation', customerConfirmBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type RefreshBookingReservationMutationVariables = Exact<{
  id: Scalars['String'];
  language: SupportedLanguage;
}>;


export type RefreshBookingReservationMutation = { __typename?: 'Mutation', createBookingPaymentIntent: string, refreshBookingReservation: { __typename?: 'RefreshBookingReservationResult', success: boolean, suggestedTimeslot?: string | null, booking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, priceModel: { __typename?: 'PriceModel', id: string }, shop: { __typename?: 'Shop', id: string, name: string, timezoneName: string, main?: boolean | null, website: string, websiteRoot: string, warrantyFromPrice: number, shopSettings?: { __typename?: 'ShopSettings', booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, preSelectNewsletter?: boolean | null, lowAvailabilityAlertThreshold?: number | null, useCustomPaymentConfirmationPage?: boolean | null, enableServerSideTracking?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', id: string, name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, currency: string, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, order?: number | null, name: string, trackingName: string, shortDescription?: string | null, description?: string | null, stock: number, price: number, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, categoryNames: Array<string>, displayedOn: Array<View>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, alcoholUnits?: number | null, rentalItem?: boolean | null, rentalStock?: number | null, imagepath?: string | null, days: Array<{ __typename?: 'ItemDays', weekday: string, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null }, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string, address?: { __typename?: 'CustomerAddress', country?: string | null } | null }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, discountedItemIds: Array<string>, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }>, discountedItems: Array<{ __typename?: 'Item', id: string, name: string }>, discountedCategories: Array<{ __typename?: 'ItemCategory', id: string, name: string }> }>, reservation?: { __typename?: 'Reservation', id: string } | null, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } }, forfeitItems: Array<{ __typename?: 'Item', id: string, name: string }> } };

export type BookingEdit_ShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, websiteRoot: string, maxBoatCount: number, mailchimp: boolean, durationOptions: Array<{ __typename?: 'BusinessDayDuration', priceLow: number, priceHigh: number, durationNumber: number, durationString: any }>, dockingLocations: Array<{ __typename?: 'DockingLocation', id: string, shopId: string, zoneId: string, name: string, address: string, default: boolean, operations: Array<DockingLocationOperation>, location: { __typename?: 'GPSCoordinates', lat: number, lng: number }, image: { __typename?: 'DockingLocationImage', cleanedSrc: string, alt?: string | null }, priceRange: { __typename?: 'DockingLocationPriceRange', low: number, high: number } }>, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null } | null, booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, preSelectNewsletter?: boolean | null, refundVoucherValidity?: number | null, lowAvailabilityAlertThreshold?: number | null, useCustomPaymentConfirmationPage?: boolean | null, enableServerSideTracking?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', id: string, name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, order?: number | null, name: string, trackingName: string, shortDescription?: string | null, description?: string | null, stock: number, price: number, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, categoryNames: Array<string>, displayedOn: Array<View>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, alcoholUnits?: number | null, rentalItem?: boolean | null, rentalStock?: number | null, imagepath?: string | null, days: Array<{ __typename?: 'ItemDays', weekday: string, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null };

export type BookingEdit_GetBookingQueryVariables = Exact<{
  id: Scalars['String'];
  language: SupportedLanguage;
}>;


export type BookingEdit_GetBookingQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', refundable: number, id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, shop: { __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, websiteRoot: string, maxBoatCount: number, mailchimp: boolean, durationOptions: Array<{ __typename?: 'BusinessDayDuration', priceLow: number, priceHigh: number, durationNumber: number, durationString: any }>, dockingLocations: Array<{ __typename?: 'DockingLocation', id: string, shopId: string, zoneId: string, name: string, address: string, default: boolean, operations: Array<DockingLocationOperation>, location: { __typename?: 'GPSCoordinates', lat: number, lng: number }, image: { __typename?: 'DockingLocationImage', cleanedSrc: string, alt?: string | null }, priceRange: { __typename?: 'DockingLocationPriceRange', low: number, high: number } }>, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null } | null, booking: { __typename?: 'ShopSettingsBooking', itemsPerPage?: number | null } } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, preSelectNewsletter?: boolean | null, refundVoucherValidity?: number | null, lowAvailabilityAlertThreshold?: number | null, useCustomPaymentConfirmationPage?: boolean | null, enableServerSideTracking?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, cancellationPolicies: Array<{ __typename?: 'CancellationPolicy', id: string, name: string, active?: boolean | null, archived?: boolean | null, default: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null }, cancellationWarranty?: { __typename?: 'CancellationPolicyDetails', location?: number | null, boatCount?: number | null, duration?: number | null, date?: number | null, startTime?: number | null, customerInfo?: number | null, extrasAdd?: number | null, extrasRemove?: number | null, cancel?: number | null, refund?: number | null, voucherRefund?: number | null } | null, options?: { __typename?: 'CancellationPolicyOptions', warrantyPurchaseCutoff?: number | null, warrantyHelpTextHeading?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null, warrantyHelpTextBody?: Array<{ __typename?: 'CancellationPolicyOptionsWarrantyHelpText', lang?: string | null, value?: string | null } | null> | null } | null }>, priceModels: Array<{ __typename?: 'PriceModel', id: string, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }>, cancellationWarranty?: { __typename?: 'PriceModelWarranty', per?: string | null, price?: number | null } | null, dockingLocationZonePrices: Array<{ __typename?: 'DockingLocationZonePrice', id: string, dockingLocationZoneId: string, price: number }> }>, items: Array<{ __typename?: 'Item', id: string, order?: number | null, name: string, trackingName: string, shortDescription?: string | null, description?: string | null, stock: number, price: number, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, categoryNames: Array<string>, displayedOn: Array<View>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, alcoholUnits?: number | null, rentalItem?: boolean | null, rentalStock?: number | null, imagepath?: string | null, days: Array<{ __typename?: 'ItemDays', weekday: string, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null }, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string, address?: { __typename?: 'CustomerAddress', country?: string | null } | null }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, discountedItemIds: Array<string>, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }>, discountedItems: Array<{ __typename?: 'Item', id: string, name: string }>, discountedCategories: Array<{ __typename?: 'ItemCategory', id: string, name: string }> }>, reservation?: { __typename?: 'Reservation', id: string } | null, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type BookingEdit_InitiatePaymentMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  reservationId: Scalars['String'];
  clientPrice: Scalars['Int'];
  subscribeToNewsletter: Scalars['Boolean'];
}>;


export type BookingEdit_InitiatePaymentMutation = { __typename?: 'Mutation', initiatePaymentEditBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type BookingEdit_InitiatePaymentPayForBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  clientPrice: Scalars['Int'];
  subscribeToNewsletter: Scalars['Boolean'];
}>;


export type BookingEdit_InitiatePaymentPayForBookingMutation = { __typename?: 'Mutation', initiatePaymentPayForBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type BookingEdit_ReserveTimeslotMutationVariables = Exact<{
  bookingId: Scalars['String'];
  boatCount: Scalars['Int'];
  duration: Scalars['Float'];
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  items: Array<ItemInput> | ItemInput;
  forfeitRentalItems: Scalars['Boolean'];
}>;


export type BookingEdit_ReserveTimeslotMutation = { __typename?: 'Mutation', reserveTimeslot: { __typename?: 'Reservation', id: string, date: string, duration: number, pickupLocationId?: string | null, dropoffLocationId?: string | null, boatCount: number, expires: string, itemReservations: Array<{ __typename?: 'ItemReservation', itemId: string, quantity: number }>, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type BookingEdit_CreateReservationPaymentIntentMutationVariables = Exact<{
  reservationId: Scalars['String'];
}>;


export type BookingEdit_CreateReservationPaymentIntentMutation = { __typename?: 'Mutation', createReservationPaymentIntent: string };

export type BookingEdit_CreatePayForBookingPaymentIntentMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type BookingEdit_CreatePayForBookingPaymentIntentMutation = { __typename?: 'Mutation', createPayForBookingPaymentIntent: string };

export type BookingEdit_UpdateCustomerMutationVariables = Exact<{
  id: Scalars['String'];
  input: CustomerInput;
}>;


export type BookingEdit_UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id: string, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null } };

export type BookingEdit_ConfirmEditBookingMutationVariables = Exact<{
  reservationId: Scalars['String'];
  subscribeToNewsletter?: InputMaybe<Scalars['Boolean']>;
}>;


export type BookingEdit_ConfirmEditBookingMutation = { __typename?: 'Mutation', confirmEditBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null } };

export type BookingEdit_CancelBookingMutationVariables = Exact<{
  id: Scalars['String'];
  voucherRefund?: InputMaybe<Scalars['Boolean']>;
}>;


export type BookingEdit_CancelBookingMutation = { __typename?: 'Mutation', cancelBooking: { __typename?: 'Booking', id: string, status: BookingStatus } };

export type BookingEdit_SetCancellationReasonMutationVariables = Exact<{
  id: Scalars['String'];
  reason: CancellationReason;
  explanation?: InputMaybe<Scalars['String']>;
}>;


export type BookingEdit_SetCancellationReasonMutation = { __typename?: 'Mutation', setCancellationReason: { __typename?: 'Booking', id: string } };

export type Giftcard_UltraMinimalShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, hidden?: boolean | null };

export type Giftcard_MinimalShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, hidden?: boolean | null, country: string, currency: string, defaultGiftcardDuration?: string | null, mailchimp: boolean, giftcardDurationOptions: Array<{ __typename?: 'GiftcardDuration', duration: any, price: number }> };

export type Giftcard_ShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, timezoneName: string, main?: boolean | null, website: string, websiteRoot: string, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null, faq?: boolean | null, paymentSuccessShowEmail?: boolean | null, introText?: { __typename?: 'ShopSettingsGiftcardIntroText', en?: string | null, da?: string | null, sv?: string | null } | null, questions?: { __typename?: 'ShopSettingsGiftcardFaqQuestions', en?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, da?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, sv?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null } | null, paymentSuccessText?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, enableCustomAmountGiftCards?: boolean | null, hideGiftCardDurations?: boolean | null, useCustomPaymentConfirmationPage?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, giftcards?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }> }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, giftCardLocalizations?: { __typename?: 'GiftCardLocalizations', heading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, instructions?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepThreeHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null };

export type Giftcard_GetShopQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type Giftcard_GetShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name: string, timezoneName: string, main?: boolean | null, website: string, websiteRoot: string, shopSettings?: { __typename?: 'ShopSettings', giftcard?: { __typename?: 'ShopSettingsGiftcard', validity?: number | null, faq?: boolean | null, paymentSuccessShowEmail?: boolean | null, introText?: { __typename?: 'ShopSettingsGiftcardIntroText', en?: string | null, da?: string | null, sv?: string | null } | null, questions?: { __typename?: 'ShopSettingsGiftcardFaqQuestions', en?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, da?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null, sv?: Array<{ __typename?: 'ShopSettingsGiftcardFaqQuestion', question?: string | null, answer?: string | null } | null> | null } | null, paymentSuccessText?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsGiftcardPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, enableCustomAmountGiftCards?: boolean | null, hideGiftCardDurations?: boolean | null, useCustomPaymentConfirmationPage?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, priceModels: Array<{ __typename?: 'PriceModel', id: string, name: string, giftcards?: boolean | null, durations: Array<{ __typename?: 'PriceModelDuration', duration: any, price: number, giftcards: boolean }> }>, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, giftCardLocalizations?: { __typename?: 'GiftCardLocalizations', heading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, instructions?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepThreeHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null } | null };

export type Giftcard_GetMinimalShopQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type Giftcard_GetMinimalShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name: string, hidden?: boolean | null, country: string, currency: string, defaultGiftcardDuration?: string | null, mailchimp: boolean, giftcardDurationOptions: Array<{ __typename?: 'GiftcardDuration', duration: any, price: number }> } | null };

export type Giftcard_GetMinimalShopsQueryVariables = Exact<{
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
}>;


export type Giftcard_GetMinimalShopsQuery = { __typename?: 'Query', getShops: Array<{ __typename?: 'Shop', id: string, name: string, hidden?: boolean | null }> };

export type Membership_ShopFieldsFragment = { __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, websiteRoot: string, mailchimp: boolean, shopSettings?: { __typename?: 'ShopSettings', membership?: { __typename?: 'ShopSettingsMembership', paymentSuccessText?: { __typename?: 'ShopSettingsMembershipPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsMembershipPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, useCustomPaymentConfirmationPage?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null };

export type Membership_GetShopQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type Membership_GetShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name: string, currency: string, timezoneName: string, country: string, main?: boolean | null, website: string, websiteRoot: string, mailchimp: boolean, shopSettings?: { __typename?: 'ShopSettings', membership?: { __typename?: 'ShopSettingsMembership', paymentSuccessText?: { __typename?: 'ShopSettingsMembershipPaymentSuccessText', en?: string | null, da?: string | null, sv?: string | null } | null, paymentSuccessLink?: { __typename?: 'ShopSettingsMembershipPaymentSuccessLink', en?: string | null, da?: string | null, sv?: string | null } | null } | null } | null, configuration?: { __typename?: 'ShopConfiguration', stripePublicKey?: string | null, gtmId?: string | null, pixelId?: string | null, termsUrl?: string | null, useCustomPaymentConfirmationPage?: boolean | null, paymentSuccessUrls?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null, featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, featureName: FeatureName, enabled: boolean }>, bookingLocalizations?: { __typename?: 'BookingLocalizations', calendarHelpText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, customerFormText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, newsletterText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, lastStepInfo?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, paymentSuccessText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, termsText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, warrantyLink?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, cancelButtonTextNoRefund?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, numberOfUnits?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, personsPerUnit?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, chooseADate?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepTwoDateAndTime?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedHeading?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, sailoutTimeReservedText?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, stepOneBoatsAndDuration?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, durationTimesUnavailable?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null, notAvailableForOnlineBooking?: { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null } | null } | null } | null };

export type BookingFieldsFragment = { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null };

export type ExtendedBookingFieldsFragment = { __typename?: 'Booking', cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string, address?: { __typename?: 'CustomerAddress', country?: string | null } | null }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, discountedItemIds: Array<string>, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }>, discountedItems: Array<{ __typename?: 'Item', id: string, name: string }>, discountedCategories: Array<{ __typename?: 'ItemCategory', id: string, name: string }> }>, reservation?: { __typename?: 'Reservation', id: string } | null, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } };

export type Booking_PriceBreakdownFieldsFragment = { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> };

export type LanguagesFragment = { __typename?: 'Localization', da?: string | null, en?: string | null, sv?: string | null, de?: string | null, es?: string | null, fr?: string | null, it?: string | null };

export type ItemDetailFieldsFragment = { __typename?: 'Item', id: string, order?: number | null, name: string, trackingName: string, shortDescription?: string | null, description?: string | null, stock: number, price: number, useCustomPreBookCutoff?: boolean | null, preBookCutoff?: number | null, categoryNames: Array<string>, displayedOn: Array<View>, preBook?: boolean | null, donation?: boolean | null, archived?: boolean | null, alcoholUnits?: number | null, rentalItem?: boolean | null, rentalStock?: number | null, imagepath?: string | null, days: Array<{ __typename?: 'ItemDays', weekday: string, available?: boolean | null }>, times?: { __typename?: 'ItemTimes', after?: string | null, before?: string | null } | null, duration?: { __typename?: 'ItemDuration', min?: number | null, max?: number | null } | null };

export type SetBookingAddonsMutationVariables = Exact<{
  bookingId: Scalars['String'];
  items: Array<ItemInput> | ItemInput;
}>;


export type SetBookingAddonsMutation = { __typename?: 'Mutation', setBookingAddons: { __typename?: 'Booking', id: string, addons: Array<{ __typename?: 'Addon', quantity: number, itemId: string }>, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type SetReservtionItemsMutationVariables = Exact<{
  reservationId: Scalars['String'];
  items: Array<ItemInput> | ItemInput;
}>;


export type SetReservtionItemsMutation = { __typename?: 'Mutation', setReservationItems: { __typename?: 'Reservation', id: string, itemReservations: Array<{ __typename?: 'ItemReservation', id: string, quantity: number, itemId: string }>, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type RemoveCancellationWarrantyMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;


export type RemoveCancellationWarrantyMutation = { __typename?: 'Mutation', removeCancellationWarranty: { __typename?: 'Booking', id: string, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> }, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string } | null } };

export type ApplyVoucherToBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  voucherCode: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['String']>;
  language: SupportedLanguage;
}>;


export type ApplyVoucherToBookingMutation = { __typename?: 'Mutation', applyVoucherToBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string, address?: { __typename?: 'CustomerAddress', country?: string | null } | null }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, discountedItemIds: Array<string>, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }>, discountedItems: Array<{ __typename?: 'Item', id: string, name: string }>, discountedCategories: Array<{ __typename?: 'ItemCategory', id: string, name: string }> }>, reservation?: { __typename?: 'Reservation', id: string } | null, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type BookingEdit_ApplyVoucherToBookingMutationVariables = Exact<{
  bookingId: Scalars['String'];
  voucherCode: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  reservationId?: InputMaybe<Scalars['String']>;
  language: SupportedLanguage;
}>;


export type BookingEdit_ApplyVoucherToBookingMutation = { __typename?: 'Mutation', applyVoucherToBooking: { __typename?: 'Booking', id: string, date: string, createdDate: string, modifiedDate?: string | null, startTime: string, endTime: string, reservedTimeslotExpires?: string | null, boatCount: number, price: number, status: BookingStatus, shopId: string, customerId: string, priceModelId?: string | null, cancellationPolicyId?: string | null, duration: number, lang?: SupportedLanguage | null, pickupLocationId?: string | null, dropoffLocationId?: string | null, reservation?: { __typename?: 'Reservation', id: string, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } | null, cancellationWarranty?: { __typename?: 'CancellationWarranty', id: string, price: number } | null, addons: Array<{ __typename?: 'Addon', id: string, quantity: number, itemId: string }>, customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, id: string, address?: { __typename?: 'CustomerAddress', country?: string | null } | null }, payments: Array<{ __typename?: 'Payment', id: string, amount: number, currency: string, type: string }>, vouchers: Array<{ __typename?: 'Voucher', type: VoucherType, value: number, description: string, start?: string | null, expires: string, code: string, maxUsage?: boolean | null, usageLimit?: number | null, category?: string | null, validFor: Array<VoucherValidFor>, creator?: string | null, id: string, shopId: string, createdDate?: string | null, modifiedDate?: string | null, discountedItemIds: Array<string>, days: Array<{ __typename?: 'VoucherDailyValidity', weekday: CapitalizedWeekday, valid: boolean }>, discountedItems: Array<{ __typename?: 'Item', id: string, name: string }>, discountedCategories: Array<{ __typename?: 'ItemCategory', id: string, name: string }> }>, priceBreakdown: { __typename?: 'BookingPriceBreakdown', boatRentalPrice: number, boatRentalPriceWithDiscount: number, pickupLocationPrice: number, dropoffLocationPrice: number, addonsPrice: number, addonsPriceWithDiscount: number, voucherValueBoatRental: number, voucherValueAddons: number, voucherValueCombined: number, bookingPrice: number, bookingPriceWithDiscount: number, donationsPrice: number, cancellationWarrantyPrice: number, totalPrice: number, tax: number, flatDiscountByVoucherId: Array<{ __typename?: 'FlatDiscountByVoucher', voucherId: string, discount: number }>, addonsBreakdown: Array<{ __typename?: 'AddonPriceBreakdown', addonId: string, itemId: string, itemName: string, quantity: number, basePrice: number, discount: number, priceWithDiscount: number }> } } };

export type GetUspBannerEntriesQueryVariables = Exact<{
  shopId: Scalars['String'];
  language: SupportedLanguage;
}>;


export type GetUspBannerEntriesQuery = { __typename?: 'Query', getUspBannerEntries: Array<{ __typename?: 'UspBannerEntry', id: string, index: number, text: string, shopId: string }> };

export type GetDockingLocationsQueryVariables = Exact<{
  shopId: Scalars['String'];
}>;


export type GetDockingLocationsQuery = { __typename?: 'Query', getDockingLocationsByShopId: Array<{ __typename?: 'DockingLocation', id: string, shopId: string, zoneId: string, name: string, address: string, default: boolean, operations: Array<DockingLocationOperation>, location: { __typename?: 'GPSCoordinates', lat: number, lng: number }, image: { __typename?: 'DockingLocationImage', cleanedSrc: string, alt?: string | null }, priceRange: { __typename?: 'DockingLocationPriceRange', low: number, high: number } }> };

export type UpdatePaymentIntentAmountMutationVariables = Exact<{
  bookingId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  reservationId?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePaymentIntentAmountMutation = { __typename?: 'Mutation', updatePaymentIntentAmount: number };

export type Booking_Generic_GetBusinessDaysQueryVariables = Exact<{
  shopId: Scalars['String'];
  after: Scalars['Date'];
  before: Scalars['Date'];
}>;


export type Booking_Generic_GetBusinessDaysQuery = { __typename?: 'Query', getBusinessDays: Array<{ __typename?: 'BusinessDay', date: string, capacity: number, priceModelId?: string | null, UTCOpeningTime?: string | null, durations: Array<{ __typename?: 'BusinessDayDuration', priceLow: number, priceHigh: number, durationString: any, durationNumber: number }> }> };

export type Booking_Generic_GetTimeslotsQueryVariables = Exact<{
  shopId: Scalars['String'];
  fromDate: Scalars['Date'];
  toDate: Scalars['Date'];
  excludeBookingId?: InputMaybe<Scalars['String']>;
  pickupLocationId?: InputMaybe<Scalars['String']>;
  dropoffLocationId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<SupportedLanguage>;
}>;


export type Booking_Generic_GetTimeslotsQuery = { __typename?: 'Query', getTimeslots: Array<{ __typename?: 'Timeslot', dateTime: string, priceModelId: string, isBlockedByMinimumNotice?: boolean | null, customerFacingText?: string | null, vacancies: Array<{ __typename?: 'Vacancy', duration: any, vacancies: number, price: number }> }> };

export type RecordSessionActivityMutationVariables = Exact<{
  input: RecordSessionActivityInput;
}>;


export type RecordSessionActivityMutation = { __typename?: 'Mutation', recordSessionActivity: boolean };

export const Booking_UltraMinimalShopFieldsFragmentDoc = gql`
    fragment Booking_UltraMinimalShopFields on Shop {
  id
  name
  hidden
}
    `;
export const Booking_MinimalShopFieldsFragmentDoc = gql`
    fragment Booking_MinimalShopFields on Shop {
  id
  name
  hidden
  maxBoatCount
  country
  currency
  defaultDuration
  durationOptions {
    priceLow
    priceHigh
    durationNumber
    durationString
  }
  mailchimp: showNewsletterSignup
  hasActiveItems
  activeProducts {
    id
    name(language: $language)
  }
}
    `;
export const LanguagesFragmentDoc = gql`
    fragment Languages on Localization {
  da
  en
  sv
  de
  es
  fr
  it
}
    `;
export const ItemDetailFieldsFragmentDoc = gql`
    fragment ItemDetailFields on Item {
  id
  order
  name(language: $language)
  trackingName
  imagepath: parsedImagePath
  shortDescription(language: $language)
  description(language: $language)
  stock
  price
  useCustomPreBookCutoff
  preBookCutoff
  categoryNames(language: $language)
  displayedOn
  preBook
  days {
    weekday
    available
  }
  times {
    after
    before
  }
  duration {
    min
    max
  }
  donation
  archived
  alcoholUnits
  rentalItem
  rentalStock
}
    `;
export const Booking_ShopFieldsFragmentDoc = gql`
    fragment Booking_ShopFields on Shop {
  id
  name
  timezoneName
  main
  website
  websiteRoot
  warrantyFromPrice
  shopSettings {
    booking {
      itemsPerPage
    }
  }
  configuration {
    stripePublicKey
    gtmId
    pixelId
    termsUrl
    paymentSuccessUrls {
      ...Languages
    }
    preSelectNewsletter
    lowAvailabilityAlertThreshold
    useCustomPaymentConfirmationPage
    enableServerSideTracking
  }
  cancellationPolicies {
    id
    name
    active
    archived
    default {
      location
      boatCount
      duration
      date
      startTime
      customerInfo
      extrasAdd
      extrasRemove
      cancel
      refund
      voucherRefund
    }
    cancellationWarranty {
      location
      boatCount
      duration
      date
      startTime
      customerInfo
      extrasAdd
      extrasRemove
      cancel
      refund
      voucherRefund
    }
    options {
      warrantyHelpTextHeading {
        lang
        value
      }
      warrantyHelpTextBody {
        lang
        value
      }
      warrantyPurchaseCutoff
    }
  }
  priceModels {
    id
    name
    currency
    durations {
      duration
      price
      giftcards
    }
    cancellationWarranty {
      per
      price
    }
    dockingLocationZonePrices {
      id
      dockingLocationZoneId
      price
    }
  }
  items: activeItems {
    ...ItemDetailFields
  }
  featureFlags {
    id
    featureName
    enabled
  }
  bookingLocalizations {
    calendarHelpText {
      ...Languages
    }
    customerFormHeading {
      ...Languages
    }
    customerFormText {
      ...Languages
    }
    paymentSuccessLink {
      ...Languages
    }
    newsletterText {
      ...Languages
    }
    lastStepInfo {
      ...Languages
    }
    paymentSuccessHeading {
      ...Languages
    }
    paymentSuccessText {
      ...Languages
    }
    termsLink {
      ...Languages
    }
    termsText {
      ...Languages
    }
    warrantyLink {
      ...Languages
    }
    cancelButtonTextRefund {
      ...Languages
    }
    cancelButtonTextNoRefund {
      ...Languages
    }
    numberOfUnits {
      ...Languages
    }
    personsPerUnit {
      ...Languages
    }
    chooseADate {
      ...Languages
    }
    stepTwoDateAndTime {
      ...Languages
    }
    sailoutTimeReservedHeading {
      ...Languages
    }
    sailoutTimeReservedText {
      ...Languages
    }
    stepOneBoatsAndDuration {
      ...Languages
    }
    durationTimesUnavailable {
      ...Languages
    }
    notAvailableForOnlineBooking {
      ...Languages
    }
  }
}
    ${LanguagesFragmentDoc}
${ItemDetailFieldsFragmentDoc}`;
export const BookingEdit_ShopFieldsFragmentDoc = gql`
    fragment BookingEdit_ShopFields on Shop {
  id
  name
  currency
  timezoneName
  country
  main
  website
  websiteRoot
  mailchimp: showNewsletterSignup
  maxBoatCount
  durationOptions {
    priceLow
    priceHigh
    durationNumber
    durationString
  }
  dockingLocations {
    id
    shopId
    zoneId
    name
    address
    default
    operations
    location {
      lat
      lng
    }
    image {
      cleanedSrc
      alt
    }
    priceRange {
      low
      high
    }
  }
  shopSettings {
    giftcard {
      validity
    }
    booking {
      itemsPerPage
    }
  }
  configuration {
    stripePublicKey
    gtmId
    pixelId
    termsUrl
    paymentSuccessUrls {
      ...Languages
    }
    preSelectNewsletter
    refundVoucherValidity
    lowAvailabilityAlertThreshold
    useCustomPaymentConfirmationPage
    enableServerSideTracking
  }
  cancellationPolicies {
    id
    name
    active
    archived
    default {
      location
      boatCount
      duration
      date
      startTime
      customerInfo
      extrasAdd
      extrasRemove
      cancel
      refund
      voucherRefund
    }
    cancellationWarranty {
      location
      boatCount
      duration
      date
      startTime
      customerInfo
      extrasAdd
      extrasRemove
      cancel
      refund
      voucherRefund
    }
    options {
      warrantyHelpTextHeading {
        lang
        value
      }
      warrantyHelpTextBody {
        lang
        value
      }
      warrantyPurchaseCutoff
    }
  }
  priceModels {
    id
    durations {
      duration
      price
      giftcards
    }
    cancellationWarranty {
      per
      price
    }
    dockingLocationZonePrices {
      id
      dockingLocationZoneId
      price
    }
  }
  items: activeItems {
    ...ItemDetailFields
  }
  featureFlags {
    id
    featureName
    enabled
  }
  bookingLocalizations {
    calendarHelpText {
      ...Languages
    }
    customerFormHeading {
      ...Languages
    }
    customerFormText {
      ...Languages
    }
    paymentSuccessLink {
      ...Languages
    }
    newsletterText {
      ...Languages
    }
    lastStepInfo {
      ...Languages
    }
    paymentSuccessHeading {
      ...Languages
    }
    paymentSuccessText {
      ...Languages
    }
    termsLink {
      ...Languages
    }
    termsText {
      ...Languages
    }
    warrantyLink {
      ...Languages
    }
    cancelButtonTextRefund {
      ...Languages
    }
    cancelButtonTextNoRefund {
      ...Languages
    }
    numberOfUnits {
      ...Languages
    }
    personsPerUnit {
      ...Languages
    }
    chooseADate {
      ...Languages
    }
    stepTwoDateAndTime {
      ...Languages
    }
    sailoutTimeReservedHeading {
      ...Languages
    }
    sailoutTimeReservedText {
      ...Languages
    }
    stepOneBoatsAndDuration {
      ...Languages
    }
    durationTimesUnavailable {
      ...Languages
    }
    notAvailableForOnlineBooking {
      ...Languages
    }
  }
}
    ${LanguagesFragmentDoc}
${ItemDetailFieldsFragmentDoc}`;
export const Giftcard_UltraMinimalShopFieldsFragmentDoc = gql`
    fragment Giftcard_UltraMinimalShopFields on Shop {
  id
  name
  hidden
}
    `;
export const Giftcard_MinimalShopFieldsFragmentDoc = gql`
    fragment Giftcard_MinimalShopFields on Shop {
  id
  name
  hidden
  country
  currency
  defaultGiftcardDuration
  giftcardDurationOptions {
    duration
    price
  }
  mailchimp: showNewsletterSignup
}
    `;
export const Giftcard_ShopFieldsFragmentDoc = gql`
    fragment Giftcard_ShopFields on Shop {
  id
  name
  timezoneName
  main
  website
  websiteRoot
  shopSettings {
    giftcard {
      validity
      introText {
        en
        da
        sv
      }
      faq
      questions {
        en {
          question
          answer
        }
        da {
          question
          answer
        }
        sv {
          question
          answer
        }
      }
      paymentSuccessText {
        en
        da
        sv
      }
      paymentSuccessLink {
        en
        da
        sv
      }
      paymentSuccessShowEmail
    }
  }
  configuration {
    stripePublicKey
    gtmId
    pixelId
    termsUrl
    paymentSuccessUrls {
      ...Languages
    }
    enableCustomAmountGiftCards
    hideGiftCardDurations
    useCustomPaymentConfirmationPage
  }
  priceModels {
    id
    name
    durations {
      duration
      price
      giftcards
    }
    giftcards
  }
  featureFlags {
    id
    featureName
    enabled
  }
  bookingLocalizations {
    calendarHelpText {
      ...Languages
    }
    customerFormHeading {
      ...Languages
    }
    customerFormText {
      ...Languages
    }
    paymentSuccessLink {
      ...Languages
    }
    newsletterText {
      ...Languages
    }
    lastStepInfo {
      ...Languages
    }
    paymentSuccessHeading {
      ...Languages
    }
    paymentSuccessText {
      ...Languages
    }
    termsLink {
      ...Languages
    }
    termsText {
      ...Languages
    }
    warrantyLink {
      ...Languages
    }
    cancelButtonTextRefund {
      ...Languages
    }
    cancelButtonTextNoRefund {
      ...Languages
    }
    numberOfUnits {
      ...Languages
    }
    personsPerUnit {
      ...Languages
    }
    chooseADate {
      ...Languages
    }
    stepTwoDateAndTime {
      ...Languages
    }
    sailoutTimeReservedHeading {
      ...Languages
    }
    sailoutTimeReservedText {
      ...Languages
    }
    stepOneBoatsAndDuration {
      ...Languages
    }
    durationTimesUnavailable {
      ...Languages
    }
    notAvailableForOnlineBooking {
      ...Languages
    }
  }
  giftCardLocalizations {
    heading {
      ...Languages
    }
    instructions {
      ...Languages
    }
    stepOneHeading {
      ...Languages
    }
    stepTwoHeading {
      ...Languages
    }
    stepThreeHeading {
      ...Languages
    }
    newsletterText {
      ...Languages
    }
  }
}
    ${LanguagesFragmentDoc}`;
export const Membership_ShopFieldsFragmentDoc = gql`
    fragment Membership_ShopFields on Shop {
  id
  name
  currency
  timezoneName
  country
  main
  website
  websiteRoot
  mailchimp: showNewsletterSignup
  shopSettings {
    membership {
      paymentSuccessText {
        en
        da
        sv
      }
      paymentSuccessLink {
        en
        da
        sv
      }
    }
  }
  configuration {
    stripePublicKey
    gtmId
    pixelId
    termsUrl
    paymentSuccessUrls {
      ...Languages
    }
    useCustomPaymentConfirmationPage
  }
  featureFlags {
    id
    featureName
    enabled
  }
  bookingLocalizations {
    calendarHelpText {
      ...Languages
    }
    customerFormHeading {
      ...Languages
    }
    customerFormText {
      ...Languages
    }
    paymentSuccessLink {
      ...Languages
    }
    newsletterText {
      ...Languages
    }
    lastStepInfo {
      ...Languages
    }
    paymentSuccessHeading {
      ...Languages
    }
    paymentSuccessText {
      ...Languages
    }
    termsLink {
      ...Languages
    }
    termsText {
      ...Languages
    }
    warrantyLink {
      ...Languages
    }
    cancelButtonTextRefund {
      ...Languages
    }
    cancelButtonTextNoRefund {
      ...Languages
    }
    numberOfUnits {
      ...Languages
    }
    personsPerUnit {
      ...Languages
    }
    chooseADate {
      ...Languages
    }
    stepTwoDateAndTime {
      ...Languages
    }
    sailoutTimeReservedHeading {
      ...Languages
    }
    sailoutTimeReservedText {
      ...Languages
    }
    stepOneBoatsAndDuration {
      ...Languages
    }
    durationTimesUnavailable {
      ...Languages
    }
    notAvailableForOnlineBooking {
      ...Languages
    }
  }
}
    ${LanguagesFragmentDoc}`;
export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  id
  date
  createdDate
  modifiedDate
  startTime
  endTime
  reservedTimeslotExpires
  boatCount
  price
  status
  shopId
  customerId
  priceModelId
  cancellationPolicyId
  duration
  lang
  pickupLocationId
  dropoffLocationId
}
    `;
export const Booking_PriceBreakdownFieldsFragmentDoc = gql`
    fragment Booking_PriceBreakdownFields on BookingPriceBreakdown {
  boatRentalPrice
  boatRentalPriceWithDiscount
  pickupLocationPrice
  dropoffLocationPrice
  addonsPrice
  addonsPriceWithDiscount
  voucherValueBoatRental
  voucherValueAddons
  voucherValueCombined
  bookingPrice
  bookingPriceWithDiscount
  donationsPrice
  cancellationWarrantyPrice
  totalPrice
  tax
  flatDiscountByVoucherId {
    voucherId
    discount
  }
  addonsBreakdown {
    addonId
    itemId
    itemName
    quantity
    basePrice
    discount
    priceWithDiscount
  }
}
    `;
export const ExtendedBookingFieldsFragmentDoc = gql`
    fragment ExtendedBookingFields on Booking {
  cancellationWarranty {
    id
    price
  }
  addons {
    id
    quantity
    itemId
  }
  customer {
    firstname
    lastname
    email
    phone
    address {
      country
    }
    id
  }
  payments {
    id
    amount
    currency
    type
  }
  vouchers {
    type
    value
    description
    start
    expires
    code
    maxUsage
    usageLimit
    category
    validFor
    creator
    id
    shopId
    createdDate
    modifiedDate
    days {
      weekday
      valid
    }
    discountedItemIds
    discountedItems {
      id
      name(language: $language)
    }
    discountedCategories {
      id
      name(language: $language)
    }
  }
  reservation {
    id
  }
  priceBreakdown {
    ...Booking_PriceBreakdownFields
  }
}
    ${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const Booking_GetMinimalShopDocument = gql`
    query booking_getMinimalShop($shopId: String!, $language: SupportedLanguage!) {
  getShop(id: $shopId) {
    ...Booking_MinimalShopFields
  }
}
    ${Booking_MinimalShopFieldsFragmentDoc}`;
export const Booking_GetMinimalShopsDocument = gql`
    query booking_getMinimalShops($city: String, $country: String) {
  getShops(city: $city, country: $country) {
    ...Booking_UltraMinimalShopFields
  }
}
    ${Booking_UltraMinimalShopFieldsFragmentDoc}`;
export const Booking_GetShopDocument = gql`
    query booking_getShop($shopId: String!, $language: SupportedLanguage!) {
  getShop(id: $shopId) {
    ...Booking_ShopFields
  }
}
    ${Booking_ShopFieldsFragmentDoc}`;
export const Booking_InitiatePaymentCreateBookingDocument = gql`
    mutation booking_initiatePaymentCreateBooking($bookingId: String!, $paymentIntentId: String!, $clientPrice: Int!, $subscribeToNewsletter: Boolean!) {
  initiatePaymentCreateBooking(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    clientPrice: $clientPrice
    subscribeToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const Booking_EditBookingDocument = gql`
    mutation booking_editBooking($id: String!, $boatCount: Int!, $duration: Float!, $date: Date!, $pickupLocationId: String, $dropoffLocationId: String, $forfeitVouchers: Boolean, $forfeitRentalItems: Boolean) {
  editBooking(
    id: $id
    boatCount: $boatCount
    duration: $duration
    date: $date
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
    forfeitVouchers: $forfeitVouchers
    forfeitRentalItems: $forfeitRentalItems
  ) {
    ...BookingFields
    addons {
      id
      quantity
      itemId
    }
    priceBreakdown {
      ...Booking_PriceBreakdownFields
    }
  }
}
    ${BookingFieldsFragmentDoc}
${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const Booking_AddCancellationWarrantyDocument = gql`
    mutation booking_addCancellationWarranty($bookingId: String!) {
  addCancellationWarranty(bookingId: $bookingId) {
    id
    cancellationWarranty {
      id
    }
    priceBreakdown {
      ...Booking_PriceBreakdownFields
    }
  }
}
    ${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const Booking_UpdateCustomerDocument = gql`
    mutation booking_updateCustomer($id: String!, $input: CustomerInput!) {
  updateCustomer(id: $id, input: $input) {
    id
  }
}
    `;
export const Booking_UpdateAndValidateCustomerDocument = gql`
    mutation booking_updateAndValidateCustomer($id: String!, $input: CustomerInput!) {
  updateAndValidateCustomer(id: $id, input: $input) {
    id
  }
}
    `;
export const Booking_ReserveDocument = gql`
    mutation booking_reserve($date: Date!, $duration: Float!, $boatCount: Int!, $productId: ID!, $customer: CustomerInput!, $lang: SupportedLanguage!, $pickupLocationId: String, $dropoffLocationId: String, $includeWarranty: Boolean!) {
  reserve(
    date: $date
    duration: $duration
    boatCount: $boatCount
    productId: $productId
    customer: $customer
    lang: $lang
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
    includeWarranty: $includeWarranty
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const Booking_CreateBookingPaymentIntentDocument = gql`
    mutation booking_createBookingPaymentIntent($bookingId: String!) {
  createBookingPaymentIntent(id: $bookingId)
}
    `;
export const Booking_ConfirmBookingDocument = gql`
    mutation booking_confirmBooking($bookingId: String!, $subToNewsletter: Boolean) {
  customerConfirmBooking(bookingId: $bookingId, subToNewsletter: $subToNewsletter) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const RefreshBookingReservationDocument = gql`
    mutation refreshBookingReservation($id: String!, $language: SupportedLanguage!) {
  refreshBookingReservation(bookingId: $id) {
    booking {
      ...BookingFields
      ...ExtendedBookingFields
      priceModel {
        id
      }
      shop {
        ...Booking_ShopFields
      }
    }
    success
    forfeitItems {
      id
      name(language: $language)
    }
    suggestedTimeslot
  }
  createBookingPaymentIntent(id: $id)
}
    ${BookingFieldsFragmentDoc}
${ExtendedBookingFieldsFragmentDoc}
${Booking_ShopFieldsFragmentDoc}`;
export const BookingEdit_GetBookingDocument = gql`
    query bookingEdit_getBooking($id: String!, $language: SupportedLanguage!) {
  getBooking(id: $id) {
    ...BookingFields
    ...ExtendedBookingFields
    refundable
    shop {
      ...BookingEdit_ShopFields
    }
  }
}
    ${BookingFieldsFragmentDoc}
${ExtendedBookingFieldsFragmentDoc}
${BookingEdit_ShopFieldsFragmentDoc}`;
export const BookingEdit_InitiatePaymentDocument = gql`
    mutation bookingEdit_initiatePayment($bookingId: String!, $paymentIntentId: String!, $reservationId: String!, $clientPrice: Int!, $subscribeToNewsletter: Boolean!) {
  initiatePaymentEditBooking(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    reservationId: $reservationId
    clientPrice: $clientPrice
    subscribeToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const BookingEdit_InitiatePaymentPayForBookingDocument = gql`
    mutation bookingEdit_initiatePaymentPayForBooking($bookingId: String!, $paymentIntentId: String!, $clientPrice: Int!, $subscribeToNewsletter: Boolean!) {
  initiatePaymentPayForBooking(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    clientPrice: $clientPrice
    subscribeToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const BookingEdit_ReserveTimeslotDocument = gql`
    mutation bookingEdit_reserveTimeslot($bookingId: String!, $boatCount: Int!, $duration: Float!, $pickupLocationId: String, $dropoffLocationId: String, $date: Date!, $items: [ItemInput!]!, $forfeitRentalItems: Boolean!) {
  reserveTimeslot(
    bookingId: $bookingId
    boatCount: $boatCount
    duration: $duration
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
    date: $date
    items: $items
    forfeitRentalItems: $forfeitRentalItems
  ) {
    id
    date
    duration
    pickupLocationId
    dropoffLocationId
    boatCount
    expires
    itemReservations {
      itemId
      quantity
    }
    priceBreakdown {
      ...Booking_PriceBreakdownFields
    }
  }
}
    ${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const BookingEdit_CreateReservationPaymentIntentDocument = gql`
    mutation bookingEdit_createReservationPaymentIntent($reservationId: String!) {
  createReservationPaymentIntent(reservationId: $reservationId)
}
    `;
export const BookingEdit_CreatePayForBookingPaymentIntentDocument = gql`
    mutation bookingEdit_createPayForBookingPaymentIntent($bookingId: String!) {
  createPayForBookingPaymentIntent(bookingId: $bookingId)
}
    `;
export const BookingEdit_UpdateCustomerDocument = gql`
    mutation bookingEdit_updateCustomer($id: String!, $input: CustomerInput!) {
  updateCustomer(id: $id, input: $input) {
    id
    email
    firstname
    lastname
    phone
  }
}
    `;
export const BookingEdit_ConfirmEditBookingDocument = gql`
    mutation bookingEdit_confirmEditBooking($reservationId: String!, $subscribeToNewsletter: Boolean) {
  confirmEditBooking(
    reservationId: $reservationId
    subToNewsletter: $subscribeToNewsletter
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const BookingEdit_CancelBookingDocument = gql`
    mutation bookingEdit_cancelBooking($id: String!, $voucherRefund: Boolean) {
  cancelBooking(id: $id, voucherRefund: $voucherRefund) {
    id
    status
  }
}
    `;
export const BookingEdit_SetCancellationReasonDocument = gql`
    mutation bookingEdit_setCancellationReason($id: String!, $reason: CancellationReason!, $explanation: String) {
  setCancellationReason(id: $id, reason: $reason, explanation: $explanation) {
    id
  }
}
    `;
export const Giftcard_GetShopDocument = gql`
    query giftcard_getShop($shopId: String!) {
  getShop(id: $shopId) {
    ...Giftcard_ShopFields
  }
}
    ${Giftcard_ShopFieldsFragmentDoc}`;
export const Giftcard_GetMinimalShopDocument = gql`
    query giftcard_getMinimalShop($shopId: String!) {
  getShop(id: $shopId) {
    ...Giftcard_MinimalShopFields
  }
}
    ${Giftcard_MinimalShopFieldsFragmentDoc}`;
export const Giftcard_GetMinimalShopsDocument = gql`
    query giftcard_getMinimalShops($city: String, $country: String) {
  getShops(city: $city, country: $country) {
    ...Giftcard_UltraMinimalShopFields
  }
}
    ${Giftcard_UltraMinimalShopFieldsFragmentDoc}`;
export const Membership_GetShopDocument = gql`
    query membership_getShop($shopId: String!) {
  getShop(id: $shopId) {
    ...Membership_ShopFields
  }
}
    ${Membership_ShopFieldsFragmentDoc}`;
export const SetBookingAddonsDocument = gql`
    mutation setBookingAddons($bookingId: String!, $items: [ItemInput!]!) {
  setBookingAddons(bookingId: $bookingId, items: $items) {
    id
    addons {
      quantity
      itemId
    }
    priceBreakdown {
      ...Booking_PriceBreakdownFields
    }
  }
}
    ${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const SetReservtionItemsDocument = gql`
    mutation setReservtionItems($reservationId: String!, $items: [ItemInput!]!) {
  setReservationItems(reservationId: $reservationId, items: $items) {
    id
    itemReservations {
      id
      quantity
      itemId
    }
    priceBreakdown {
      ...Booking_PriceBreakdownFields
    }
  }
}
    ${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const RemoveCancellationWarrantyDocument = gql`
    mutation removeCancellationWarranty($bookingId: String!) {
  removeCancellationWarranty(bookingId: $bookingId) {
    id
    priceBreakdown {
      ...Booking_PriceBreakdownFields
    }
    cancellationWarranty {
      id
    }
  }
}
    ${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const ApplyVoucherToBookingDocument = gql`
    mutation applyVoucherToBooking($bookingId: String!, $voucherCode: String!, $paymentIntentId: String, $reservationId: String, $language: SupportedLanguage!) {
  applyVoucherToBooking(
    bookingId: $bookingId
    voucherCode: $voucherCode
    paymentIntentId: $paymentIntentId
    reservationId: $reservationId
  ) {
    ...BookingFields
    ...ExtendedBookingFields
  }
}
    ${BookingFieldsFragmentDoc}
${ExtendedBookingFieldsFragmentDoc}`;
export const BookingEdit_ApplyVoucherToBookingDocument = gql`
    mutation BookingEdit_applyVoucherToBooking($bookingId: String!, $voucherCode: String!, $paymentIntentId: String, $reservationId: String, $language: SupportedLanguage!) {
  applyVoucherToBooking(
    bookingId: $bookingId
    voucherCode: $voucherCode
    paymentIntentId: $paymentIntentId
    reservationId: $reservationId
  ) {
    ...BookingFields
    ...ExtendedBookingFields
    reservation {
      id
      priceBreakdown {
        ...Booking_PriceBreakdownFields
      }
    }
  }
}
    ${BookingFieldsFragmentDoc}
${ExtendedBookingFieldsFragmentDoc}
${Booking_PriceBreakdownFieldsFragmentDoc}`;
export const GetUspBannerEntriesDocument = gql`
    query getUspBannerEntries($shopId: String!, $language: SupportedLanguage!) {
  getUspBannerEntries(shopId: $shopId, language: $language) {
    id
    index
    text
    shopId
  }
}
    `;
export const GetDockingLocationsDocument = gql`
    query getDockingLocations($shopId: String!) {
  getDockingLocationsByShopId(shopId: $shopId) {
    id
    shopId
    zoneId
    name
    address
    default
    operations
    location {
      lat
      lng
    }
    image {
      cleanedSrc
      alt
    }
    priceRange {
      low
      high
    }
  }
}
    `;
export const UpdatePaymentIntentAmountDocument = gql`
    mutation updatePaymentIntentAmount($bookingId: String!, $paymentIntentId: String!, $reservationId: String) {
  updatePaymentIntentAmount(
    bookingId: $bookingId
    paymentIntentId: $paymentIntentId
    reservationId: $reservationId
  )
}
    `;
export const Booking_Generic_GetBusinessDaysDocument = gql`
    query booking_generic_getBusinessDays($shopId: String!, $after: Date!, $before: Date!) {
  getBusinessDays(shopId: $shopId, after: $after, before: $before) {
    date
    capacity
    priceModelId
    UTCOpeningTime
    durations {
      priceLow
      priceHigh
      durationString
      durationNumber
    }
  }
}
    `;
export const Booking_Generic_GetTimeslotsDocument = gql`
    query booking_generic_getTimeslots($shopId: String!, $fromDate: Date!, $toDate: Date!, $excludeBookingId: String, $pickupLocationId: String, $dropoffLocationId: String, $language: SupportedLanguage) {
  getTimeslots(
    shopId: $shopId
    fromDate: $fromDate
    toDate: $toDate
    excludeBookingId: $excludeBookingId
    excludeInvalidSailoutTimes: true
    pickupLocationId: $pickupLocationId
    dropoffLocationId: $dropoffLocationId
    language: $language
  ) {
    dateTime
    priceModelId
    isBlockedByMinimumNotice
    vacancies {
      duration
      vacancies
      price
    }
    customerFacingText
  }
}
    `;
export const RecordSessionActivityDocument = gql`
    mutation recordSessionActivity($input: RecordSessionActivityInput!) {
  recordSessionActivity(input: $input)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    booking_getMinimalShop(variables: Booking_GetMinimalShopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_GetMinimalShopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_GetMinimalShopQuery>(Booking_GetMinimalShopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_getMinimalShop', 'query');
    },
    booking_getMinimalShops(variables?: Booking_GetMinimalShopsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_GetMinimalShopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_GetMinimalShopsQuery>(Booking_GetMinimalShopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_getMinimalShops', 'query');
    },
    booking_getShop(variables: Booking_GetShopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_GetShopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_GetShopQuery>(Booking_GetShopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_getShop', 'query');
    },
    booking_initiatePaymentCreateBooking(variables: Booking_InitiatePaymentCreateBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_InitiatePaymentCreateBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_InitiatePaymentCreateBookingMutation>(Booking_InitiatePaymentCreateBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_initiatePaymentCreateBooking', 'mutation');
    },
    booking_editBooking(variables: Booking_EditBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_EditBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_EditBookingMutation>(Booking_EditBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_editBooking', 'mutation');
    },
    booking_addCancellationWarranty(variables: Booking_AddCancellationWarrantyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_AddCancellationWarrantyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_AddCancellationWarrantyMutation>(Booking_AddCancellationWarrantyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_addCancellationWarranty', 'mutation');
    },
    booking_updateCustomer(variables: Booking_UpdateCustomerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_UpdateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_UpdateCustomerMutation>(Booking_UpdateCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_updateCustomer', 'mutation');
    },
    booking_updateAndValidateCustomer(variables: Booking_UpdateAndValidateCustomerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_UpdateAndValidateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_UpdateAndValidateCustomerMutation>(Booking_UpdateAndValidateCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_updateAndValidateCustomer', 'mutation');
    },
    booking_reserve(variables: Booking_ReserveMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_ReserveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_ReserveMutation>(Booking_ReserveDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_reserve', 'mutation');
    },
    booking_createBookingPaymentIntent(variables: Booking_CreateBookingPaymentIntentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_CreateBookingPaymentIntentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_CreateBookingPaymentIntentMutation>(Booking_CreateBookingPaymentIntentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_createBookingPaymentIntent', 'mutation');
    },
    booking_confirmBooking(variables: Booking_ConfirmBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_ConfirmBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_ConfirmBookingMutation>(Booking_ConfirmBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_confirmBooking', 'mutation');
    },
    refreshBookingReservation(variables: RefreshBookingReservationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RefreshBookingReservationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshBookingReservationMutation>(RefreshBookingReservationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refreshBookingReservation', 'mutation');
    },
    bookingEdit_getBooking(variables: BookingEdit_GetBookingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_GetBookingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_GetBookingQuery>(BookingEdit_GetBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_getBooking', 'query');
    },
    bookingEdit_initiatePayment(variables: BookingEdit_InitiatePaymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_InitiatePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_InitiatePaymentMutation>(BookingEdit_InitiatePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_initiatePayment', 'mutation');
    },
    bookingEdit_initiatePaymentPayForBooking(variables: BookingEdit_InitiatePaymentPayForBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_InitiatePaymentPayForBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_InitiatePaymentPayForBookingMutation>(BookingEdit_InitiatePaymentPayForBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_initiatePaymentPayForBooking', 'mutation');
    },
    bookingEdit_reserveTimeslot(variables: BookingEdit_ReserveTimeslotMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_ReserveTimeslotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_ReserveTimeslotMutation>(BookingEdit_ReserveTimeslotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_reserveTimeslot', 'mutation');
    },
    bookingEdit_createReservationPaymentIntent(variables: BookingEdit_CreateReservationPaymentIntentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_CreateReservationPaymentIntentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_CreateReservationPaymentIntentMutation>(BookingEdit_CreateReservationPaymentIntentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_createReservationPaymentIntent', 'mutation');
    },
    bookingEdit_createPayForBookingPaymentIntent(variables: BookingEdit_CreatePayForBookingPaymentIntentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_CreatePayForBookingPaymentIntentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_CreatePayForBookingPaymentIntentMutation>(BookingEdit_CreatePayForBookingPaymentIntentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_createPayForBookingPaymentIntent', 'mutation');
    },
    bookingEdit_updateCustomer(variables: BookingEdit_UpdateCustomerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_UpdateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_UpdateCustomerMutation>(BookingEdit_UpdateCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_updateCustomer', 'mutation');
    },
    bookingEdit_confirmEditBooking(variables: BookingEdit_ConfirmEditBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_ConfirmEditBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_ConfirmEditBookingMutation>(BookingEdit_ConfirmEditBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_confirmEditBooking', 'mutation');
    },
    bookingEdit_cancelBooking(variables: BookingEdit_CancelBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_CancelBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_CancelBookingMutation>(BookingEdit_CancelBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_cancelBooking', 'mutation');
    },
    bookingEdit_setCancellationReason(variables: BookingEdit_SetCancellationReasonMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_SetCancellationReasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_SetCancellationReasonMutation>(BookingEdit_SetCancellationReasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookingEdit_setCancellationReason', 'mutation');
    },
    giftcard_getShop(variables: Giftcard_GetShopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Giftcard_GetShopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Giftcard_GetShopQuery>(Giftcard_GetShopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'giftcard_getShop', 'query');
    },
    giftcard_getMinimalShop(variables: Giftcard_GetMinimalShopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Giftcard_GetMinimalShopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Giftcard_GetMinimalShopQuery>(Giftcard_GetMinimalShopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'giftcard_getMinimalShop', 'query');
    },
    giftcard_getMinimalShops(variables?: Giftcard_GetMinimalShopsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Giftcard_GetMinimalShopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Giftcard_GetMinimalShopsQuery>(Giftcard_GetMinimalShopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'giftcard_getMinimalShops', 'query');
    },
    membership_getShop(variables: Membership_GetShopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Membership_GetShopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Membership_GetShopQuery>(Membership_GetShopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'membership_getShop', 'query');
    },
    setBookingAddons(variables: SetBookingAddonsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetBookingAddonsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetBookingAddonsMutation>(SetBookingAddonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setBookingAddons', 'mutation');
    },
    setReservtionItems(variables: SetReservtionItemsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetReservtionItemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetReservtionItemsMutation>(SetReservtionItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setReservtionItems', 'mutation');
    },
    removeCancellationWarranty(variables: RemoveCancellationWarrantyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveCancellationWarrantyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCancellationWarrantyMutation>(RemoveCancellationWarrantyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCancellationWarranty', 'mutation');
    },
    applyVoucherToBooking(variables: ApplyVoucherToBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ApplyVoucherToBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyVoucherToBookingMutation>(ApplyVoucherToBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyVoucherToBooking', 'mutation');
    },
    BookingEdit_applyVoucherToBooking(variables: BookingEdit_ApplyVoucherToBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingEdit_ApplyVoucherToBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingEdit_ApplyVoucherToBookingMutation>(BookingEdit_ApplyVoucherToBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingEdit_applyVoucherToBooking', 'mutation');
    },
    getUspBannerEntries(variables: GetUspBannerEntriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUspBannerEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUspBannerEntriesQuery>(GetUspBannerEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUspBannerEntries', 'query');
    },
    getDockingLocations(variables: GetDockingLocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDockingLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDockingLocationsQuery>(GetDockingLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDockingLocations', 'query');
    },
    updatePaymentIntentAmount(variables: UpdatePaymentIntentAmountMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePaymentIntentAmountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentIntentAmountMutation>(UpdatePaymentIntentAmountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePaymentIntentAmount', 'mutation');
    },
    booking_generic_getBusinessDays(variables: Booking_Generic_GetBusinessDaysQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_Generic_GetBusinessDaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_Generic_GetBusinessDaysQuery>(Booking_Generic_GetBusinessDaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_generic_getBusinessDays', 'query');
    },
    booking_generic_getTimeslots(variables: Booking_Generic_GetTimeslotsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Booking_Generic_GetTimeslotsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Booking_Generic_GetTimeslotsQuery>(Booking_Generic_GetTimeslotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'booking_generic_getTimeslots', 'query');
    },
    recordSessionActivity(variables: RecordSessionActivityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RecordSessionActivityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordSessionActivityMutation>(RecordSessionActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recordSessionActivity', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;